import { useState, useRef, useEffect, Fragment } from "react"
import { SiloGauge, SiloDetailPanel, SiloBalanceView, ZoneGauge, SinterBelt, SinteringLineView } from './SharedComponents'

// ─── PXLG Panel — clone of PXTK "Thiết bị" with PXLG data ───

const PXLG_DATA = [
  { id:"LG.NL.BLN", name:"Boongke liệu ngầm", type:"Boongke/Silo", qty:1, since:"09/2015", status:"ok", alarm:false, lastSeen:"12/03/2026 08:00" },
  { id:"LG.NL.MLR", name:"Máy cấp liệu ngầm", type:"Máy", qty:1, since:"09/2015", status:"ok", alarm:false, lastSeen:"12/03/2026 08:00" },
  { id:"LG.NL.P2LN", name:"Palang điện 2 tấn liệu ngầm", type:"Thiết bị nâng", qty:1, since:"09/2015", status:"ok", alarm:false, lastSeen:"12/03/2026 08:00" },
  { id:"LG.NL.BT01", name:"Băng tải số 1 (Băng tải lên liệu ngầm)", type:"Băng tải", qty:1, since:"09/2015", status:"ok", alarm:false, lastSeen:"12/03/2026 08:00" },
  { id:"LG.NL.SCT", name:"Sàng rung trạm chuyển tiếp", type:"Sàng", qty:2, since:"09/2015", status:"ok", alarm:false, lastSeen:"12/03/2026 08:00" },
  { id:"LG.NL.P2CT", name:"Palang điện 2 tấn trạm chuyển tiếp", type:"Thiết bị nâng", qty:1, since:"09/2015", status:"ok", alarm:false, lastSeen:"12/03/2026 08:00" },
  { id:"LG.NL.BT02", name:"Băng tải số 2 (Băng tải hướng Đông)", type:"Băng tải", qty:1, since:"09/2015", status:"ok", alarm:false, lastSeen:"12/03/2026 08:00" },
  { id:"LG.NL.BT03", name:"Băng tải số 3 (Băng tải hướng Tây)", type:"Băng tải", qty:1, since:"09/2015", status:"ok", alarm:false, lastSeen:"12/03/2026 08:00" },
  { id:"LG.NL.P2DT", name:"Palang điện 2 tấn băng tải Đông - Tây", type:"Băng tải", qty:1, since:"09/2015", status:"ok", alarm:false, lastSeen:"12/03/2026 08:00" },
  { id:"LG.NL.BLLC", name:"Boongke chứa liệu lò cao", type:"Boongke/Silo", qty:8, since:"09/2015", status:"ok", alarm:false, lastSeen:"12/03/2026 08:00" },
  { id:"LG.NL.SRQL", name:"Sàng rung bong ke quặng lò cao", type:"Khác", qty:8, since:"09/2015", status:"ok", alarm:false, lastSeen:"12/03/2026 08:00" },
  { id:"LG.NL.BT04", name:"Băng tải số 4 (Băng tải lên liệu Lò cao 1)", type:"Băng tải", qty:1, since:"09/2015", status:"ok", alarm:false, lastSeen:"12/03/2026 08:00" },
  { id:"LG.NL.BT05", name:"Băng tải số 5 (Băng tải lên liệu Lò cao 2)", type:"Băng tải", qty:1, since:"09/2015", status:"ok", alarm:false, lastSeen:"12/03/2026 08:00" },
  { id:"LG.NL.P2B5", name:"Palang điện 2 tấn băng tải số 5", type:"Băng tải", qty:1, since:"09/2015", status:"ok", alarm:false, lastSeen:"12/03/2026 08:00" },
  { id:"LG.NL.BT06", name:"Băng tải số 6 (Băng tải quặng phản)", type:"Băng tải", qty:1, since:"09/2015", status:"ok", alarm:false, lastSeen:"12/03/2026 08:00" },
  { id:"LG.NL.BT07", name:"Băng tải số 7 (Băng tải gầu quặng phản)", type:"Băng tải", qty:1, since:"09/2015", status:"ok", alarm:false, lastSeen:"12/03/2026 08:00" },
  { id:"LG.NL.BT08", name:"Băng tải số 8 (Băng tải than phản)", type:"Băng tải", qty:1, since:"09/2016", status:"ok", alarm:false, lastSeen:"12/03/2026 08:00" },
  { id:"LG.NL.BT09", name:"Băng tải số 9 (Băng tải gầu than phản)", type:"Băng tải", qty:1, since:"09/2017", status:"ok", alarm:false, lastSeen:"12/03/2026 08:00" },
  { id:"LG.NL.BCTV", name:"Boongke chứa than đầu vào", type:"Boongke/Silo", qty:1, since:"09/2015", status:"ok", alarm:false, lastSeen:"12/03/2026 08:00" },
  { id:"LG.NL.BT10", name:"Băng tải số 10 ( băng tải lên sàng)", type:"Băng tải", qty:1, since:"09/2015", status:"ok", alarm:false, lastSeen:"12/03/2026 08:00" },
  { id:"LG.NL.S250", name:"Sàng than Cos250", type:"Sàng", qty:1, since:"09/2015", status:"ok", alarm:false, lastSeen:"12/03/2026 08:00" },
  { id:"LG.NL.BT11", name:"Băng tải số 11 ( Băng tải than mịn)", type:"Băng tải", qty:1, since:"09/2015", status:"ok", alarm:false, lastSeen:"12/03/2026 08:00" },
  { id:"LG.NL.BT12", name:"Băng tải số 12 (Băng tải lên sàng số 2)", type:"Băng tải", qty:1, since:"09/2015", status:"ok", alarm:false, lastSeen:"12/03/2026 08:00" },
  { id:"LG.NL.BT13", name:"Băng tải số 13 (Băng tải dưới sàng 2)", type:"Băng tải", qty:1, since:"09/2015", status:"ok", alarm:false, lastSeen:"12/03/2026 08:00" },
  { id:"LG.NL.BT14", name:"Băng tải số 14 (Băng tải trên sàng 2)", type:"Băng tải", qty:1, since:"09/2015", status:"ok", alarm:false, lastSeen:"12/03/2026 08:00" },
  { id:"LG.NL.BT15", name:"Băng tải số 15 ( Băng tải liệu trên sàng)", type:"Băng tải", qty:1, since:"09/2015", status:"ok", alarm:false, lastSeen:"12/03/2026 08:00" },
  { id:"LG.NL.BT16", name:"Băng tải số 16 (Băng tải than qua đường cos250)", type:"Băng tải", qty:1, since:"09/2015", status:"ok", alarm:false, lastSeen:"12/03/2026 08:00" },
  { id:"LG.NL.LBCT", name:"Lọc bụi túi vải trạm chuyển tiếp", type:"Khác", qty:1, since:"09/2015", status:"ok", alarm:false, lastSeen:"12/03/2026 08:00" },
  { id:"LG.NL.LBQL", name:"Lọc bụi túi vải bong ke quặng lò cao", type:"Khác", qty:1, since:"09/2015", status:"ok", alarm:false, lastSeen:"12/03/2026 08:00" },
  { id:"LG.NL.04KV", name:"Hệ thống điện 0,4kV nạp liệu", type:"Điện", qty:1, since:"09/2015", status:"ok", alarm:false, lastSeen:"12/03/2026 08:00" },
  { id:"LG.LC.LC", name:"Lò cao 179m3", type:"Khác", qty:1, since:"09/2015", status:"ok", alarm:false, lastSeen:"12/03/2026 08:00" },
  { id:"LG.LC.P5DL", name:"Palang điện 5 tấn đỉnh lò", type:"Thiết bị nâng", qty:1, since:"09/2015", status:"ok", alarm:false, lastSeen:"12/03/2026 08:00" },
  { id:"LG.LC.MKG", name:"Máy khoan cửa ra gang", type:"Máy", qty:1, since:"09/2015", status:"ok", alarm:false, lastSeen:"12/03/2026 08:00" },
  { id:"LG.LC.MBB", name:"Máy bắn bùn bịt cửa gang", type:"Máy", qty:1, since:"09/2015", status:"ok", alarm:false, lastSeen:"12/03/2026 08:00" },
  { id:"LG.LC.P5TL", name:"Cầu trục 5 tấn trước lò", type:"Khác", qty:1, since:"09/2015", status:"ok", alarm:false, lastSeen:"12/03/2026 08:00" },
  { id:"LG.LC.BTHL", name:"Bơm nước tuần hoàn lò cao", type:"Bơm", qty:3, since:"09/2015", status:"ok", alarm:false, lastSeen:"12/03/2026 08:00" },
  { id:"LG.LC.BTTM", name:"Bơm nước tuần hoàn tháp làm mát", type:"Bơm", qty:3, since:"09/2015", status:"ok", alarm:false, lastSeen:"12/03/2026 08:00" },
  { id:"LG.LC.TLM", name:"Tháp làm mát", type:"Khác", qty:3, since:"09/2015", status:"ok", alarm:false, lastSeen:"12/03/2026 08:00" },
  { id:"LG.LC.BXX", name:"Bơm xối xỉ", type:"Bơm", qty:2, since:"09/2015", status:"ok", alarm:false, lastSeen:"12/03/2026 08:00" },
  { id:"LG.LC.BXB", name:"Bể xỉ bông", type:"Khác", qty:1, since:"09/2015", status:"ok", alarm:false, lastSeen:"12/03/2026 08:00" },
  { id:"LG.LC.CT5GN", name:"Cầu trục gầu ngoạm bể xỉ 5 tấn", type:"Thiết bị nâng", qty:1, since:"09/2015", status:"ok", alarm:false, lastSeen:"12/03/2026 08:00" },
  { id:"LG.LC.CT50XS", name:"Cầu trục dầm đôi 50/10t (Gian xây sửa thùng)", type:"Khác", qty:1, since:"09/2015", status:"ok", alarm:false, lastSeen:"12/03/2026 08:00" },
  { id:"LG.LC.DTH.01", name:"Đầu máy xe lửa số 1", type:"Khác", qty:1, since:"09/2015", status:"ok", alarm:false, lastSeen:"12/03/2026 08:00" },
  { id:"LG.LC.DTH.02", name:"Đầu máy xe lửa số 2", type:"Khác", qty:1, since:"09/2015", status:"ok", alarm:false, lastSeen:"12/03/2026 08:00" },
  { id:"LG.LC.DRTH", name:"Đường ray xe lửa", type:"Khác", qty:1, since:"09/2015", status:"ok", alarm:false, lastSeen:"12/03/2026 08:00" },
  { id:"LG.LC.LBTL", name:"Hệ thống lọc bụi túi vải trước lò", type:"Khác", qty:1, since:"09/2015", status:"ok", alarm:false, lastSeen:"12/03/2026 08:00" },
  { id:"LG.LC.OKT", name:"Hệ thống đường ống cung cấp khí than cho phân xưởng luyện gang", type:"Đường ống", qty:1, since:"10/2015", status:"ok", alarm:false, lastSeen:"12/03/2026 08:00" },
  { id:"LG.LC.DOK", name:"Hệ thống đường ống khí Oxy, khí Ni-tơ, khí nén", type:"Đường ống", qty:1, since:"10/2015", status:"ok", alarm:false, lastSeen:"12/03/2026 08:00" },
  { id:"LG.LC.DON", name:"Hệ thống đường ống cung cấp nước cho phân xưởng luyện gang", type:"Đường ống", qty:1, since:"10/2015", status:"ok", alarm:false, lastSeen:"12/03/2026 08:00" },
  { id:"LG.LC.DKGS", name:"Hệ thống điều khiển giám sát phòng trung tâm", type:"Điều khiển", qty:1, since:"09/2015", status:"ok", alarm:false, lastSeen:"12/03/2026 08:00" },
  { id:"LG.LC.04KV", name:"Hệ thống điện 0,4kV lò cao", type:"Điện", qty:1, since:"09/2015", status:"ok", alarm:false, lastSeen:"12/03/2026 08:00" },
  { id:"LG.GN.LGN", name:"Lò gió nóng", type:"Lò", qty:3, since:"09/2015", status:"ok", alarm:false, lastSeen:"12/03/2026 08:00" },
  { id:"LG.GN.QTD", name:"Hệ thống quạt trợ đốt", type:"Quạt", qty:2, since:"09/2015", status:"ok", alarm:false, lastSeen:"12/03/2026 08:00" },
  { id:"LG.GN.OKG", name:"Ống khói gạch", type:"Đường ống", qty:1, since:"09/2015", status:"ok", alarm:false, lastSeen:"12/03/2026 08:00" },
  { id:"LG.GN.04KV", name:"Hệ thống điện 0,4kV lò gió nóng", type:"Điện", qty:1, since:"09/2015", status:"ok", alarm:false, lastSeen:"12/03/2026 08:00" },
  { id:"LG.GN.LBTL", name:"Lọc bụi trọng lực", type:"Khác", qty:1, since:"09/2015", status:"ok", alarm:false, lastSeen:"12/03/2026 08:00" },
  { id:"LG.GN.LBKT", name:"Tháp lọc bụi túi vải khí than", type:"Tháp", qty:6, since:"09/2015", status:"ok", alarm:false, lastSeen:"12/03/2026 08:00" },
  { id:"LG.GN.TTL", name:"Trạm thủy lực lò gió nóng", type:"Lò", qty:1, since:"09/2015", status:"ok", alarm:false, lastSeen:"12/03/2026 08:00" },
  { id:"LG.GN.DKGS", name:"Hệ thống điều khiển giám sát hệ thống lọc bụi và lò gió nóng", type:"Điều khiển", qty:1, since:"09/2015", status:"ok", alarm:false, lastSeen:"12/03/2026 08:00" },
  { id:"LG.GN.04KV", name:"Hệ thống điện 0,4kV hệ thống lọc bụi và lò gió nóng", type:"Điện", qty:1, since:"09/2015", status:"ok", alarm:false, lastSeen:"12/03/2026 08:00" },
  { id:"LG.PT.BT17", name:"Băng tải số 17 (Băng tải tai bèo than)", type:"Băng tải", qty:1, since:"09/2015", status:"ok", alarm:false, lastSeen:"12/03/2026 08:00" },
  { id:"LG.PT.BT18", name:"Băng tải số 18 (Băng tải cấp than lên gầu xích)", type:"Băng tải", qty:1, since:"09/2015", status:"ok", alarm:false, lastSeen:"12/03/2026 08:00" },
  { id:"LG.PT.BTT", name:"Băng tải từ lọc sắt", type:"Băng tải", qty:1, since:"09/2015", status:"ok", alarm:false, lastSeen:"12/03/2026 08:00" },
  { id:"LG.PT.GXT", name:"Gầu xích", type:"Khác", qty:1, since:"09/2015", status:"ok", alarm:false, lastSeen:"12/03/2026 08:00" },
  { id:"LG.PT.BT19", name:"Băng tải 19 (Băng tải cấp than DP)", type:"Băng tải", qty:1, since:"09/2015", status:"ok", alarm:false, lastSeen:"12/03/2026 08:00" },
  { id:"LG.PT.BCT", name:"Boongke chứa than thô", type:"Boongke/Silo", qty:1, since:"09/2015", status:"ok", alarm:false, lastSeen:"12/03/2026 08:00" },
  { id:"LG.PT.CBT", name:"Cân băng tải định lượng", type:"Băng tải", qty:1, since:"09/2015", status:"ok", alarm:false, lastSeen:"12/03/2026 08:00" },
  { id:"LG.PT.QHG", name:"Quạt hút gió", type:"Quạt", qty:1, since:"09/2015", status:"ok", alarm:false, lastSeen:"12/03/2026 08:00" },
  { id:"LG.PT.MNT", name:"Máy nghiền than", type:"Khác", qty:1, since:"09/2015", status:"ok", alarm:false, lastSeen:"12/03/2026 08:00" },
  { id:"LG.PT.PBT", name:"Hệ thống phun thổi bột than", type:"Khác", qty:1, since:"09/2015", status:"ok", alarm:false, lastSeen:"12/03/2026 08:00" },
  { id:"LG.PT.MST", name:"Máy sấy than", type:"Máy", qty:1, since:"09/2015", status:"ok", alarm:false, lastSeen:"12/03/2026 08:00" },
  { id:"LG.PT.LKK", name:"Lò khí khói", type:"Lò", qty:1, since:"09/2015", status:"ok", alarm:false, lastSeen:"12/03/2026 08:00" },
  { id:"LG.PT.LGO", name:"Hệ thống làm giàu khí Oxy", type:"Khác", qty:1, since:"09/2015", status:"ok", alarm:false, lastSeen:"12/03/2026 08:00" },
  { id:"LG.PT.P5.NT", name:"Palang điện 5 tấn", type:"Thiết bị nâng", qty:1, since:"09/2015", status:"ok", alarm:false, lastSeen:"12/03/2026 08:00" },
  { id:"LG.PT.T5NT", name:"Tời mặt đất 5 tấn", type:"Thiết bị nâng", qty:1, since:"09/2015", status:"ok", alarm:false, lastSeen:"12/03/2026 08:00" },
  { id:"LG.PT.P2NT", name:"Palang điện 2 tấn", type:"Thiết bị nâng", qty:1, since:"09/2015", status:"ok", alarm:false, lastSeen:"12/03/2026 08:00" },
  { id:"LG.PT.DKGS", name:"Hệ thống điều khiển giám sát phun than", type:"Điều khiển", qty:1, since:"09/2015", status:"ok", alarm:false, lastSeen:"12/03/2026 08:00" },
  { id:"LG.PT.04KV", name:"Hệ thống điện 0,4kV phun than", type:"Điện", qty:1, since:"09/2015", status:"ok", alarm:false, lastSeen:"12/03/2026 08:00" },
  { id:"DH.KLH.LG", name:"Hệ thống điều hòa phân xưởng Luyện gang", type:"Khác", qty:1, since:"09/2015", status:"ok", alarm:false, lastSeen:"12/03/2026 08:00" },
]

const PXLG_STATUS_STYLES = {
  running: { bg:"#dcfce7", color:"#16a34a", label:"Đang chạy" },
  stopped: { bg:"#fee2e2", color:"#dc2626", label:"Dừng"      },
  open:    { bg:"#dbeafe", color:"#2563eb", label:"Mở"        },
  ok:      { bg:"#f1f5f9", color:"#64748b", label:"OK"        },
}


// ─── Phối Liệu Lò Cao ─────────────────────────────────────

// data
const LC_BINS = [
  { id:"BN-01", label:"Ore Bin 1",  fill:72, cap:100,  flow:+8.6, unit:"t",  color:"#64748b", active:true,  alarm:false, type:"Quặng" },
  { id:"BN-02", label:"Ore Bin 2",  fill:0,  cap:0,    flow:0,    unit:"t",  color:"#64748b", active:false, alarm:false, type:"Quặng" },
  { id:"BN-03", label:"Ore Bin 3",  fill:58, cap:1400, flow:+5.2, unit:"t",  color:"#64748b", active:true,  alarm:false, type:"Quặng" },
  { id:"BN-04", label:"Ore Bin 4",  fill:81, cap:2000, flow:+6.1, unit:"t",  color:"#64748b", active:true,  alarm:false, type:"Quặng" },
  { id:"BN-05", label:"Ore Bin 5",  fill:65, cap:2000, flow:+4.8, unit:"t",  color:"#64748b", active:true,  alarm:false, type:"Quặng" },
  { id:"BN-06", label:"Flux Bin",   fill:44, cap:50,   flow:+1.8, unit:"t",  color:"#2563eb", active:true,  alarm:false, type:"Flux"  },
  { id:"BN-07", label:"Coke Bin 1", fill:77, cap:740,  flow:+3.2, unit:"t",  color:"#92400e", active:true,  alarm:false, type:"Cốc"  },
  { id:"BN-08", label:"Coke Bin 2", fill:53, cap:730,  flow:+2.9, unit:"t",  color:"#92400e", active:true,  alarm:false, type:"Cốc"  },
]
const LC_OUTPUTS = [
  { id:"GS-01", label:"Gang lỏng",      icon:"🔥", flow:-142,  unit:"t/ngày", color:"#ef4444", active:true,  bins:["BN-03","BN-04","BN-05","BN-07","BN-08"] },
  { id:"GS-02", label:"Xỉ lỏng",        icon:"🌋", flow:-48,   unit:"t/ngày", color:"#f97316", active:true,  bins:["BN-06"] },
  { id:"GS-03", label:"Khí than lò cao",icon:"💨", flow:-6638, unit:"Nm³/h",  color:"#2563eb", active:true,  bins:[] },
  { id:"GS-04", label:"Khí thải",       icon:"🌫", flow:-820,  unit:"Nm³/h",  color:"#94a3b8", active:true,  bins:[] },
]
const LC_PARAMS = [
  { key:"Nhiệt độ đỉnh lò",  val:"105",   unit:"°C",    alarm:false },
  { key:"Áp suất đỉnh lò",   val:"40.0",  unit:"kPa",   alarm:false },
  { key:"Nhiệt độ gió nóng", val:"1050",  unit:"°C",    alarm:false },
  { key:"Lưu lượng gió",     val:"1 240", unit:"m³/h",  alarm:false },
  { key:"Áp suất gió nóng",  val:"1.85",  unit:"bar",   alarm:false },
  { key:"Lưu lượng oxy",     val:"320",   unit:"Nm³/h", alarm:false },
  { key:"Nhiệt độ gang ra",  val:"1 450", unit:"°C",    alarm:false },
  { key:"Tỷ lệ cốc/quặng",  val:"0.304", unit:"",      alarm:false },
]
const LC_HOT_STOVES = [
  { id:"LGN-1", burning:false, temp:820  },
  { id:"LGN-2", burning:true,  temp:1050 },
  { id:"LGN-3", burning:false, temp:760  },
]

// ── Clean furnace schematic (white-bg, matches SiloGauge style) ──
function FurnaceSchema({ active=true, width=80, height=110 }) {
  const c   = active ? "#ef4444" : "#cbd5e1"
  const fc  = active ? "#fee2e2" : "#f8fafc"
  const W=width, H=height
  const cx  = W/2
  return (
    <svg viewBox={`0 0 ${W} ${H}`} style={{width:W, height:H, display:"block", flexShrink:0}}>
      {/* Stack (top) */}
      <rect x={cx-16} y={2} width={32} height={26} rx={3}
        fill={fc} stroke={c} strokeWidth={1.5}/>
      {/* Bell */}
      <ellipse cx={cx} cy={28} rx={14} ry={4}
        fill={active?"#fde68a":"#e2e8f0"} stroke={c} strokeWidth={1}/>
      {/* Shaft */}
      <polygon points={`${cx-18},28 ${cx+18},28 ${cx+22},66 ${cx-22},66`}
        fill={fc} stroke={c} strokeWidth={1.5}/>
      {/* Belly */}
      <rect x={cx-22} y={66} width={44} height={14} rx={1}
        fill={active?"#fca5a5":"#e2e8f0"} stroke={c} strokeWidth={1.5}/>
      {/* Bosh */}
      <polygon points={`${cx-22},80 ${cx+22},80 ${cx+17},100 ${cx-17},100`}
        fill={fc} stroke={c} strokeWidth={1.5}/>
      {/* Hearth */}
      <rect x={cx-17} y={100} width={34} height={H-100} rx={2}
        fill={active?"#ef4444":"#cbd5e1"} stroke={c} strokeWidth={1.5}/>
      {/* Tuyères */}
      {[70,78,86].map((y,i)=>(
        <g key={i}>
          <rect x={6}   y={y} width={8} height={4} rx={1} fill={active?"#2563eb":"#e2e8f0"}/>
          <rect x={W-14} y={y} width={8} height={4} rx={1} fill={active?"#2563eb":"#e2e8f0"}/>
        </g>
      ))}
      {/* Tap hole */}
      <rect x={cx-5} y={H-4} width={10} height={4} rx={1}
        fill={active?"#f97316":"#94a3b8"}/>
      {/* Gas outlet top */}
      {active && <polygon points={`${cx-4},2 ${cx+4},2 ${cx},−4`} fill="#22c55e"/>}
      {/* Labels */}
      <text x={cx} y={17} textAnchor="middle" fontSize={7} fontWeight="700"
        fill={active?"#92400e":"#94a3b8"}>STACK</text>
      <text x={cx} y={50} textAnchor="middle" fontSize={7} fontWeight="700"
        fill={active?"#b91c1c":"#94a3b8"}>SHAFT</text>
      <text x={cx} y={93} textAnchor="middle" fontSize={6}
        fill={active?"#991b1b":"#94a3b8"}>BOSH</text>
    </svg>
  )
}

function LoCaoView() {
  const [sel,       setSel]       = useState(null)  // {type:"bin"|"output"|"furnace", data}
  const [hoveredId, setHoveredId] = useState(null)
  const [furnaceOn, setFurnaceOn] = useState(true)

  const totalMass  = LC_BINS.filter(b=>b.active).reduce((s,b)=>s+b.fill/100*b.cap,0).toFixed(0)
  const totalCap   = LC_BINS.reduce((s,b)=>s+b.cap,0)
  const avgFill    = (LC_BINS.filter(b=>b.active).reduce((s,b)=>s+b.fill,0)/LC_BINS.filter(b=>b.active).length).toFixed(0)
  const alarmCount = LC_BINS.filter(b=>b.alarm).length

  // ── exact same helpers as SiloBalanceView ──
  const HPipe = ({color="#22c55e", active=true, flow=0, width=28}) => (
    <div style={{display:"flex",flexDirection:"column",alignItems:"center",gap:1,flexShrink:0}}>
      <div style={{
        width, height:3,
        background:active?color:"#e2e8f0", borderRadius:2,
        opacity:active?1:0.5,
        boxShadow:active?`0 0 4px ${color}66`:"none",
        transition:"all .2s"
      }}/>
      {flow!==0 && (
        <span style={{fontSize:7,color:active?color:"#94a3b8",fontWeight:600,whiteSpace:"nowrap"}}>
          {flow>0?`+${flow}`:flow} t/h
        </span>
      )}
    </div>
  )

  const Arrow = ({color="#22c55e", active=true, dir="right"}) => (
    <span style={{
      fontSize:10, color:active?color:"#e2e8f0",
      flexShrink:0, lineHeight:1,
      filter:active?`drop-shadow(0 0 2px ${color}88)`:"none"
    }}>{dir==="right"?"▶":"◀"}</span>
  )

  const ColHeader = ({title, count, onAdd=()=>{}}) => (
    <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",marginBottom:12}}>
      <span style={{fontSize:11,fontWeight:700,color:"#64748b",letterSpacing:1,textTransform:"uppercase"}}>
        {title} <span style={{fontWeight:400,fontSize:10,color:"#94a3b8"}}>({count})</span>
      </span>
      <button onClick={onAdd} style={{
        width:22,height:22,borderRadius:"50%",background:"#22c55e",border:"none",
        cursor:"pointer",fontSize:14,color:"white",
        display:"flex",alignItems:"center",justifyContent:"center",
        boxShadow:"0 1px 4px rgba(34,197,94,.4)",flexShrink:0
      }}>+</button>
    </div>
  )

  // ── Detail panel — mirrors SiloDetailPanel structure exactly ──
  const DetailPanel = () => {
    if (!sel) return (
      <div style={{
        height:"100%",display:"flex",flexDirection:"column",
        alignItems:"center",justifyContent:"center",
        color:"#94a3b8",fontSize:12,padding:20,textAlign:"center",gap:8
      }}>
        <span style={{fontSize:32}}>🏭</span>
        <span style={{fontWeight:600,color:"#64748b"}}>Chọn một phần tử</span>
        <span style={{fontSize:11,color:"#cbd5e1",lineHeight:1.5}}>
          Nhấp vào bin, lò hoặc đầu ra để hiển thị thông tin
        </span>
      </div>
    )

    const d       = sel.data
    const isBin   = sel.type==="bin"
    const isLo    = sel.type==="furnace"
    const isOut   = sel.type==="output"
    const color   = isLo?"#ef4444":d.color
    const trendData = Array.from({length:24},(_,i)=>{
      const base = isBin?d.fill:isOut?Math.abs(d.flow)%100:75
      return Math.max(5, Math.min(99, base+(Math.random()-.5)*14+Math.sin(i/3)*6))
    })
    const barMax  = Math.max(...trendData)

    return (
      <div>
        {/* Header */}
        <div style={{
          padding:"10px 14px",background:"#f8fafc",borderBottom:"1px solid #e2e8f0",
          display:"flex",alignItems:"center",justifyContent:"space-between"
        }}>
          <div>
            <span style={{fontSize:9,color:"#94a3b8",fontFamily:"monospace"}}>
              {isLo?"LC-01":d.id} ·{" "}
            </span>
            <span style={{fontSize:12,fontWeight:700,color:"#0f172a"}}>
              {isLo?"Lò cao 179m³":d.label}
            </span>
          </div>
          <div style={{display:"flex",gap:6,alignItems:"center"}}>
            {!isLo && d.alarm && (
              <span style={{width:18,height:18,borderRadius:"50%",background:"#ef4444",
                display:"inline-flex",alignItems:"center",justifyContent:"center",
                fontSize:9,color:"white",fontWeight:900}}>!</span>
            )}
            <button style={{background:"none",border:"none",cursor:"pointer",color:"#94a3b8",fontSize:16}}>⋯</button>
          </div>
        </div>

        {/* Sub-tabs */}
        <div style={{display:"flex",borderBottom:"1px solid #f1f5f9"}}>
          {["Thông tin","Cảnh báo"].map((t,i)=>(
            <button key={t} style={{
              padding:"8px 12px",border:"none",cursor:"pointer",fontSize:11,
              fontWeight:i===0?700:400,color:i===0?"#2563eb":"#94a3b8",
              borderBottom:i===0?"2px solid #2563eb":"2px solid transparent",
              background:"none"
            }}>{t}</button>
          ))}
        </div>

        {/* Gauge + live value (bin) */}
        {isBin && (
          <div style={{
            padding:"14px",display:"flex",gap:14,alignItems:"center",
            background:"white",borderBottom:"1px solid #f1f5f9"
          }}>
            <SiloGauge fill={d.fill} color={d.color} alarm={d.alarm} width={44} height={80}/>
            <div style={{flex:1}}>
              <div style={{fontSize:22,fontWeight:800,color:d.alarm&&d.fill>88?"#ef4444":"#0f172a",lineHeight:1}}>
                {(d.fill/100*d.cap).toFixed(1)}
                <span style={{fontSize:12,fontWeight:400,color:"#94a3b8",marginLeft:4}}>t</span>
              </div>
              <div style={{fontSize:10,color:"#64748b",marginTop:3}}>Sức chứa: {d.cap} t</div>
              <div style={{
                marginTop:6,display:"inline-flex",alignItems:"center",gap:4,
                background:d.active&&!d.alarm?"#dcfce7":d.alarm?"#fee2e2":"#f1f5f9",
                color:d.active&&!d.alarm?"#16a34a":d.alarm?"#dc2626":"#64748b",
                padding:"2px 8px",borderRadius:10,fontSize:10,fontWeight:600
              }}>
                {d.active&&!d.alarm?"Đang chạy":d.alarm?"Cảnh báo":"Dừng"}
              </div>
            </div>
          </div>
        )}

        {/* Furnace schema (furnace) */}
        {isLo && (
          <div style={{
            padding:"14px",display:"flex",gap:14,alignItems:"center",
            background:"white",borderBottom:"1px solid #f1f5f9"
          }}>
            <FurnaceSchema active={furnaceOn} width={80} height={110}/>
            <div style={{flex:1}}>
              <div style={{fontSize:14,fontWeight:800,color:"#0f172a",lineHeight:1}}>179 m³</div>
              <div style={{fontSize:10,color:"#64748b",marginTop:3}}>Lò cao 1</div>
              <div style={{
                marginTop:6,display:"inline-flex",alignItems:"center",gap:4,
                background:furnaceOn?"#dcfce7":"#fee2e2",
                padding:"2px 8px",borderRadius:10,fontSize:10,fontWeight:600,
                color:furnaceOn?"#16a34a":"#dc2626"
              }}>
                <div style={{width:6,height:6,borderRadius:"50%",
                  background:furnaceOn?"#22c55e":"#ef4444",
                  boxShadow:furnaceOn?"0 0 4px #22c55e":"none"}}/>
                {furnaceOn?"Đang chạy":"Dừng"}
              </div>
            </div>
          </div>
        )}

        {/* Fields */}
        {(isBin ? [
          ["Type liệu",  d.type],
          ["Mức điền",   `${d.fill}%`],
          ["Lưu lượng",  `${d.flow>0?"+":""}${d.flow} t/h`],
          ["Trạng thái", d.active?"Đang chạy":"Dừng"],
          ["Cảnh báo",   d.alarm?"⚠ Có":"Không"],
        ] : isLo ? LC_PARAMS.map(p=>[p.key,`${p.val}${p.unit?" "+p.unit:""}`])
          : [
          ["Lưu lượng",     `${Math.abs(d.flow)} ${d.unit}`],
          ["Hướng",         "◀ Ra"],
          ["Trạng thái",    d.active?"Đang chạy":"Dừng"],
          ["Bin liên kết",  d.bins.join(", ")||"—"],
        ]).map(([k,v])=>(
          <div key={k} style={{
            display:"flex",justifyContent:"space-between",alignItems:"center",
            padding:"6px 14px",borderBottom:"1px solid #f8fafc"
          }}>
            <span style={{fontSize:11,color:"#94a3b8"}}>{k}</span>
            <span style={{fontSize:11,fontWeight:600,
              color:k==="Cảnh báo"&&!isLo&&d.alarm?"#ef4444":
                    k==="Trạng thái"?(d.active||isLo&&furnaceOn?"#16a34a":"#dc2626"):"#0f172a"}}>{v}</span>
          </div>
        ))}

        {/* Trend */}
        <div style={{padding:"8px 14px 2px",fontSize:9,fontWeight:700,
          color:"#94a3b8",letterSpacing:1,background:"#f8fafc",marginTop:4}}>
          DERNIÈRES 24H
        </div>
        <div style={{padding:"6px 14px 14px",background:"#f8fafc"}}>
          <div style={{display:"flex",alignItems:"flex-end",gap:1,height:52}}>
            {trendData.map((v,i)=>{
              const h = (v/barMax)*100
              const c = v>88&&isBin&&d.alarm?"#ef4444":color
              return (
                <div key={i} style={{
                  flex:1,height:`${h}%`,background:c,
                  borderRadius:"1px 1px 0 0",opacity:0.85
                }}/>
              )
            })}
          </div>
          <div style={{display:"flex",justifyContent:"space-between",marginTop:3}}>
            <span style={{fontSize:7,color:"#94a3b8"}}>-24h</span>
            <span style={{fontSize:7,color:"#94a3b8"}}>hiện tại</span>
          </div>
        </div>
      </div>
    )
  }

  return (
    <div style={{flex:1,display:"flex",overflow:"hidden"}}>

      {/* ── Main 3-column canvas ── */}
      <div style={{flex:1,overflow:"auto",padding:"14px 16px"}}>

        {/* KPI strip — exact same card style as SiloBalanceView */}
        <div style={{display:"flex",gap:8,marginBottom:14,flexWrap:"wrap"}}>
          {[
            {label:"Khối lượng bin",   value:`${totalMass} t`,              icon:"⚖",  color:"#2563eb"},
            {label:"Tổng dung tích",   value:`${totalCap} t`,               icon:"🗄",  color:"#64748b"},
            {label:"Mức điền TB",      value:`${avgFill}%`,                 icon:"📊", color:"#22c55e"},
            {label:"Cảnh báo",         value:`${alarmCount}`,               icon:"⚠",  color:alarmCount>0?"#ef4444":"#22c55e"},
            {label:"Sản lượng gang",   value:"142 t/ngày",                  icon:"🔥",  color:"#ef4444"},
            {label:"Tỷ lệ cốc/quặng", value:"0.304",                       icon:"📐", color:"#92400e"},
          ].map(k=>(
            <div key={k.label} style={{
              background:"white",border:"1px solid #e2e8f0",borderRadius:8,
              padding:"8px 12px",display:"flex",alignItems:"center",gap:8,flex:1,minWidth:100,
              boxShadow:"0 1px 3px rgba(0,0,0,0.04)"
            }}>
              <span style={{fontSize:18}}>{k.icon}</span>
              <div>
                <div style={{fontSize:15,fontWeight:800,color:k.color,lineHeight:1}}>{k.value}</div>
                <div style={{fontSize:9,color:"#94a3b8",marginTop:1}}>{k.label}</div>
              </div>
            </div>
          ))}
        </div>

        {/* 3-column synoptic flow */}
        <div style={{display:"flex",gap:0,minWidth:700}}>

          {/* ── COL 1 : BIN LIỆU — 2×4 grid, mirrors silo grid ── */}
          <div style={{flex:1.6,borderRight:"1px solid #e2e8f0",paddingRight:12}}>
            <ColHeader title="Bin liệu" count={LC_BINS.length}/>
            <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:8}}>
              {LC_BINS.map(bin=>{
                const isSel = sel?.data?.id===bin.id
                const isHov = hoveredId===bin.id
                const ss    = bin.active&&!bin.alarm
                  ? {bg:"#dcfce7",color:"#16a34a",label:"Đang chạy"}
                  : bin.alarm
                  ? {bg:"#fee2e2",color:"#dc2626",label:"Cảnh báo"}
                  : {bg:"#f1f5f9",color:"#64748b",label:"Dừng"}
                return (
                  <div key={bin.id}
                    onClick={()=>setSel(prev=>prev?.data?.id===bin.id?null:{type:"bin",data:bin})}
                    onMouseEnter={()=>setHoveredId(bin.id)}
                    onMouseLeave={()=>setHoveredId(null)}
                    style={{
                      background:"white",
                      border:`2px solid ${isSel?"#2563eb":bin.alarm?"#fca5a5":"#e2e8f0"}`,
                      borderRadius:8,padding:"10px",cursor:"pointer",
                      boxShadow:isSel?"0 0 0 3px rgba(37,99,235,.15)":isHov?"0 2px 8px rgba(0,0,0,0.08)":"0 1px 3px rgba(0,0,0,0.04)",
                      transition:"all .15s",position:"relative",
                      opacity:bin.active?1:0.6
                    }}
                  >
                    {/* Alarm badge */}
                    {bin.alarm && (
                      <div style={{
                        position:"absolute",top:-7,right:-7,
                        width:18,height:18,borderRadius:"50%",background:"#ef4444",
                        display:"flex",alignItems:"center",justifyContent:"center",
                        boxShadow:"0 2px 6px rgba(239,68,68,.45)",zIndex:2
                      }}>
                        <span style={{fontSize:8,color:"white",fontWeight:900}}>!</span>
                      </div>
                    )}
                    {/* Flow arrows in */}
                    <div style={{display:"flex",alignItems:"center",gap:3,marginBottom:8}}>
                      {bin.active && (
                        <div style={{display:"flex",alignItems:"center",gap:2}}>
                          <div style={{width:10,height:3,background:bin.color,borderRadius:2,
                            boxShadow:`0 0 3px ${bin.color}88`}}/>
                          <span style={{fontSize:8,color:bin.color}}>▶</span>
                        </div>
                      )}
                      <div style={{flex:1}}/>
                      {bin.active && (
                        <div style={{display:"flex",alignItems:"center",gap:2}}>
                          <span style={{fontSize:8,color:bin.color}}>▶</span>
                          <div style={{width:10,height:3,background:bin.color,borderRadius:2,
                            boxShadow:`0 0 3px ${bin.color}88`}}/>
                        </div>
                      )}
                    </div>
                    {/* Gauge + info — exact SiloBalanceView silo card layout */}
                    <div style={{display:"flex",gap:8,alignItems:"center"}}>
                      <SiloGauge fill={bin.fill} color={bin.color} alarm={bin.alarm} width={40} height={68}/>
                      <div style={{flex:1,minWidth:0}}>
                        <div style={{fontSize:10,fontWeight:700,color:"#374151",lineHeight:1.2,marginBottom:3}}>
                          {bin.label}
                        </div>
                        <div style={{fontSize:8,fontFamily:"monospace",color:"#94a3b8",marginBottom:5}}>
                          {bin.id}
                        </div>
                        <div style={{fontSize:14,fontWeight:800,
                          color:bin.alarm&&bin.fill>88?"#ef4444":"#0f172a",lineHeight:1}}>
                          {(bin.fill/100*bin.cap).toFixed(0)}
                          <span style={{fontSize:9,fontWeight:400,color:"#94a3b8",marginLeft:2}}>t</span>
                        </div>
                        <div style={{fontSize:8,color:"#94a3b8",marginTop:1}}>/ {bin.cap} t</div>
                        {/* Flow badge */}
                        <div style={{
                          marginTop:5,display:"inline-flex",fontSize:8,fontWeight:600,
                          padding:"1px 6px",borderRadius:8,
                          background:bin.flow>0?"#dcfce7":bin.flow<0?"#fef3c7":"#f1f5f9",
                          color:bin.flow>0?"#16a34a":bin.flow<0?"#92400e":"#64748b"
                        }}>
                          {bin.flow>0?`▲ +${bin.flow}`:bin.flow<0?`▼ ${bin.flow}`:"—"} t/h
                        </div>
                        {/* Status chip */}
                        <div style={{
                          marginTop:4,display:"inline-flex",alignItems:"center",gap:3,
                          background:ss.bg,color:ss.color,
                          padding:"1px 6px",borderRadius:8,fontSize:8,fontWeight:600,
                          marginLeft:4
                        }}>{ss.label}</div>
                      </div>
                    </div>
                  </div>
                )
              })}
            </div>
          </div>

          {/* ── COL 2 : LÒ CAO ── */}
          <div style={{flex:1,borderRight:"1px solid #e2e8f0",padding:"0 12px"}}>
            {/* Header with start/stop */}
            <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",marginBottom:12}}>
              <span style={{fontSize:11,fontWeight:700,color:"#64748b",letterSpacing:1,textTransform:"uppercase"}}>
                Lò cao <span style={{fontWeight:400,fontSize:10,color:"#94a3b8"}}>(1)</span>
              </span>
              <div style={{display:"flex",gap:4}}>
                <button onClick={()=>setFurnaceOn(true)} style={{
                  padding:"3px 8px",border:"none",borderRadius:5,cursor:"pointer",fontSize:9,fontWeight:600,
                  background:furnaceOn?"#22c55e":"#f1f5f9",color:furnaceOn?"white":"#64748b",
                  boxShadow:furnaceOn?"0 1px 4px rgba(34,197,94,.4)":"none"
                }}>▶</button>
                <button onClick={()=>setFurnaceOn(false)} style={{
                  padding:"3px 8px",border:"none",borderRadius:5,cursor:"pointer",fontSize:9,fontWeight:600,
                  background:!furnaceOn?"#ef4444":"#f1f5f9",color:!furnaceOn?"white":"#64748b"
                }}>■</button>
              </div>
            </div>

            {/* Furnace card — same style as silo card */}
            <div
              onClick={()=>setSel(prev=>prev?.type==="furnace"?null:{type:"furnace",data:{}})}
              style={{
                background:"white",
                border:`2px solid ${sel?.type==="furnace"?"#2563eb":"#e2e8f0"}`,
                borderRadius:8,padding:"10px",cursor:"pointer",marginBottom:10,
                boxShadow:sel?.type==="furnace"
                  ?"0 0 0 3px rgba(37,99,235,.15)"
                  :"0 1px 3px rgba(0,0,0,0.04)",
                transition:"all .15s",position:"relative"
              }}>
              {/* Status dot (like silo alarm badge but for running state) */}
              <div style={{
                position:"absolute",top:-7,right:-7,
                width:18,height:18,borderRadius:"50%",
                background:furnaceOn?"#22c55e":"#ef4444",
                display:"flex",alignItems:"center",justifyContent:"center",
                boxShadow:furnaceOn?"0 2px 6px rgba(34,197,94,.45)":"0 2px 6px rgba(239,68,68,.45)"
              }}>
                <span style={{fontSize:8,color:"white",fontWeight:900}}>{furnaceOn?"▶":"■"}</span>
              </div>
              {/* Flow in arrows (from bins) */}
              <div style={{display:"flex",alignItems:"center",gap:3,marginBottom:8}}>
                {["#64748b","#2563eb","#92400e"].map((c,i)=>(
                  <div key={i} style={{display:"flex",alignItems:"center",gap:2}}>
                    <div style={{width:8,height:3,background:c,borderRadius:2,
                      boxShadow:`0 0 3px ${c}88`,opacity:furnaceOn?1:0.3}}/>
                    <span style={{fontSize:8,color:c,opacity:furnaceOn?1:0.3}}>▶</span>
                  </div>
                ))}
                <div style={{flex:1}}/>
                <span style={{fontSize:8,color:furnaceOn?"#ef4444":"#94a3b8"}}>▶</span>
                <div style={{width:8,height:3,background:furnaceOn?"#ef4444":"#e2e8f0",borderRadius:2}}/>
              </div>
              {/* Schematic + params */}
              <div style={{display:"flex",gap:10,alignItems:"flex-start"}}>
                <FurnaceSchema active={furnaceOn} width={80} height={110}/>
                <div style={{flex:1,minWidth:0}}>
                  <div style={{fontSize:11,fontWeight:700,color:"#374151",lineHeight:1.2,marginBottom:4}}>
                    Lò cao 179m³
                  </div>
                  <div style={{fontSize:8,fontFamily:"monospace",color:"#94a3b8",marginBottom:6}}>LC-01</div>
                  <div style={{
                    display:"inline-flex",alignItems:"center",gap:4,
                    background:furnaceOn?"#dcfce7":"#fee2e2",
                    padding:"2px 8px",borderRadius:10,fontSize:9,fontWeight:600,
                    color:furnaceOn?"#16a34a":"#dc2626",marginBottom:8
                  }}>
                    <div style={{width:5,height:5,borderRadius:"50%",
                      background:furnaceOn?"#22c55e":"#ef4444",
                      boxShadow:furnaceOn?"0 0 4px #22c55e":"none"}}/>
                    {furnaceOn?"Đang chạy":"Dừng"}
                  </div>
                  {/* Key params */}
                  {LC_PARAMS.slice(0,5).map(p=>(
                    <div key={p.key} style={{
                      display:"flex",justifyContent:"space-between",
                      padding:"2px 0",borderBottom:"1px solid #f8fafc"
                    }}>
                      <span style={{fontSize:8,color:"#94a3b8"}}>{p.key}</span>
                      <span style={{fontSize:9,fontWeight:700,fontFamily:"monospace",
                        color:p.alarm?"#ef4444":"#0f172a"}}>
                        {p.val} <span style={{fontSize:7,fontWeight:400,color:"#94a3b8"}}>{p.unit}</span>
                      </span>
                    </div>
                  ))}
                </div>
              </div>
            </div>

            {/* Lò gió nóng — flow cards, same style as FlowCard */}
            <div style={{fontSize:10,fontWeight:700,color:"#64748b",
              letterSpacing:1,textTransform:"uppercase",marginBottom:8}}>
              Lò gió nóng (3)
            </div>
            {LC_HOT_STOVES.map(s=>(
              <div key={s.id} style={{
                background:"white",border:`2px solid ${s.burning?"#fca5a5":"#e2e8f0"}`,
                borderRadius:8,padding:"8px 12px",cursor:"pointer",marginBottom:6,
                boxShadow:s.burning?"0 0 0 2px rgba(239,68,68,.08)":"none",
                opacity:1,transition:"all .15s"
              }}>
                <div style={{display:"flex",alignItems:"center",gap:6,marginBottom:4}}>
                  <span style={{fontSize:14}}>{s.burning?"🔥":"○"}</span>
                  <div style={{flex:1}}>
                    <div style={{fontSize:11,fontWeight:700,color:"#374151"}}>{s.id}</div>
                    <div style={{fontSize:9,fontFamily:"monospace",color:"#94a3b8"}}>{s.burning?"Đốt":"Dự trữ"}</div>
                  </div>
                  <span style={{
                    fontSize:9,background:s.burning?"#fee2e2":"#f1f5f9",
                    color:s.burning?"#dc2626":"#64748b",
                    padding:"1px 6px",borderRadius:8,fontWeight:600
                  }}>{s.burning?"Hoạt động":"Chờ"}</span>
                </div>
                {/* flow row — exact FlowCard style */}
                <div style={{display:"flex",alignItems:"center",gap:4}}>
                  <div style={{width:14,height:3,background:s.burning?"#ef4444":"#e2e8f0",borderRadius:2}}/>
                  <svg viewBox="0 0 28 18" style={{width:28,height:18,flexShrink:0}}>
                    <rect x={1} y={2} width={12} height={14} rx={2} fill="white"
                      stroke={s.burning?"#ef4444":"#e2e8f0"} strokeWidth={1.5}/>
                    <circle cx={7} cy={9} r={3} fill={s.burning?"#ef4444":"#e2e8f0"} opacity={0.3}/>
                    <circle cx={7} cy={9} r={1.5} fill={s.burning?"#ef4444":"#e2e8f0"}/>
                    <line x1={13} y1={9} x2={18} y2={9}
                      stroke={s.burning?"#ef4444":"#e2e8f0"} strokeWidth={1.5}/>
                    <rect x={18} y={2} width={9} height={14} rx={2} fill="white"
                      stroke={s.burning?"#ef4444":"#e2e8f0"} strokeWidth={1.5}/>
                  </svg>
                  <div style={{width:6,height:3,background:s.burning?"#ef4444":"#e2e8f0",borderRadius:2}}/>
                  <Arrow color="#ef4444" active={s.burning} dir="right"/>
                  <div style={{flex:1,textAlign:"right"}}>
                    <span style={{fontSize:13,fontWeight:800,color:s.burning?"#ef4444":"#94a3b8"}}>
                      {s.temp}
                    </span>
                    <span style={{fontSize:9,color:"#94a3b8",marginLeft:2}}>°C</span>
                  </div>
                </div>
              </div>
            ))}

            {/* Mẻ liệu strip */}
            <div style={{
              background:"white",border:"1px solid #e2e8f0",borderRadius:8,
              padding:"8px 10px",marginTop:4,
              boxShadow:"0 1px 3px rgba(0,0,0,0.04)"
            }}>
              <div style={{fontSize:9,fontWeight:700,color:"#64748b",
                letterSpacing:1,textTransform:"uppercase",marginBottom:8}}>Mẻ liệu hiện tại</div>
              <div style={{display:"flex",gap:6}}>
                {[
                  {label:"Quặng",val:"2.04",unit:"t",color:"#64748b"},
                  {label:"Cốc",  val:"0.62",unit:"t",color:"#92400e"},
                  {label:"Flux", val:"0.18",unit:"t",color:"#2563eb"},
                ].map(b=>(
                  <div key={b.label} style={{flex:1,textAlign:"center",
                    background:"#f8fafc",borderRadius:5,padding:"4px 2px"}}>
                    <div style={{fontSize:12,fontWeight:800,color:b.color,fontFamily:"monospace",lineHeight:1}}>
                      {b.val}
                    </div>
                    <div style={{fontSize:8,color:"#94a3b8",marginTop:2}}>{b.label} ({b.unit})</div>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* ── COL 3 : ĐẦU RA — exact FlowCard pattern ── */}
          <div style={{flex:1,paddingLeft:12}}>
            <ColHeader title="Đầu ra" count={LC_OUTPUTS.length}/>

            {LC_OUTPUTS.map(out=>{
              const isSel = sel?.data?.id===out.id
              const isHov = hoveredId===out.id
              return (
                <div key={out.id}
                  onClick={()=>setSel(prev=>prev?.data?.id===out.id?null:{type:"output",data:out})}
                  onMouseEnter={()=>setHoveredId(out.id)}
                  onMouseLeave={()=>setHoveredId(null)}
                  style={{
                    background:"white",
                    border:`2px solid ${isSel?"#2563eb":out.active?"#e2e8f0":"#f1f5f9"}`,
                    borderRadius:8,padding:"10px 12px",cursor:"pointer",marginBottom:8,
                    boxShadow:isSel?"0 0 0 3px rgba(37,99,235,.15)":isHov?"0 2px 8px rgba(0,0,0,0.08)":"none",
                    transition:"all .15s",opacity:out.active?1:0.6
                  }}>
                  {/* Header row */}
                  <div style={{display:"flex",alignItems:"center",gap:6,marginBottom:6}}>
                    <span style={{fontSize:16}}>{out.icon}</span>
                    <div style={{flex:1}}>
                      <div style={{fontSize:11,fontWeight:700,color:"#374151"}}>{out.label}</div>
                      <div style={{fontSize:9,fontFamily:"monospace",color:"#94a3b8"}}>{out.id}</div>
                    </div>
                    {!out.active && (
                      <span style={{fontSize:9,background:"#fee2e2",color:"#dc2626",
                        padding:"1px 6px",borderRadius:8,fontWeight:600}}>Dừng</span>
                    )}
                  </div>
                  {/* Flow row — exact FlowCard mini SVG node pattern */}
                  <div style={{display:"flex",alignItems:"center",gap:4}}>
                    <div style={{width:14,height:3,background:out.active?out.color:"#e2e8f0",borderRadius:2}}/>
                    <svg viewBox="0 0 28 18" style={{width:28,height:18,flexShrink:0}}>
                      <rect x={1} y={2} width={12} height={14} rx={2} fill="white"
                        stroke={out.active?out.color:"#e2e8f0"} strokeWidth={1.5}/>
                      <circle cx={7} cy={9} r={3} fill={out.active?out.color:"#e2e8f0"} opacity={0.3}/>
                      <circle cx={7} cy={9} r={1.5} fill={out.active?out.color:"#e2e8f0"}/>
                      <line x1={13} y1={9} x2={18} y2={9}
                        stroke={out.active?out.color:"#e2e8f0"} strokeWidth={1.5}/>
                      <rect x={18} y={2} width={9} height={14} rx={2} fill="white"
                        stroke={out.active?out.color:"#e2e8f0"} strokeWidth={1.5}/>
                    </svg>
                    <div style={{width:6,height:3,background:out.active?out.color:"#e2e8f0",borderRadius:2}}/>
                    <Arrow color={out.color} active={out.active} dir="left"/>
                    <div style={{flex:1,textAlign:"right"}}>
                      <span style={{fontSize:13,fontWeight:800,
                        color:out.active?out.color:"#94a3b8"}}>
                        {Math.abs(out.flow)}
                      </span>
                      <span style={{fontSize:9,color:"#94a3b8",marginLeft:2}}>{out.unit}</span>
                    </div>
                  </div>
                  {/* Linked bins chips */}
                  {out.bins.length>0 && (
                    <div style={{display:"flex",gap:3,marginTop:6,flexWrap:"wrap"}}>
                      {out.bins.map(bid=>(
                        <span key={bid} style={{
                          fontSize:8,fontFamily:"monospace",background:"#f1f5f9",
                          color:"#64748b",padding:"1px 5px",borderRadius:4
                        }}>{bid}</span>
                      ))}
                    </div>
                  )}
                </div>
              )
            })}

            {/* Công phụ card */}
            <div style={{
              background:"white",border:"1px solid #e2e8f0",borderRadius:8,
              padding:"8px 12px",marginTop:4,
              boxShadow:"0 1px 3px rgba(0,0,0,0.04)"
            }}>
              <div style={{fontSize:9,fontWeight:700,color:"#64748b",
                letterSpacing:1,textTransform:"uppercase",marginBottom:8}}>Công phụ</div>
              {[
                {label:"Lưu lượng oxy",   val:"320",  unit:"Nm³/h", color:"#2563eb"},
                {label:"Áp suất khí nén", val:"4.2",  unit:"kPa",   color:"#64748b"},
                {label:"Lưu lượng nước",  val:"860",  unit:"m³/h",  color:"#0ea5e9"},
                {label:"Khí than (BFG)",  val:"6 638", unit:"Nm³/h",color:"#64748b"},
              ].map(p=>(
                <div key={p.label} style={{
                  display:"flex",justifyContent:"space-between",
                  padding:"5px 0",borderBottom:"1px solid #f8fafc"
                }}>
                  <span style={{fontSize:10,color:"#94a3b8"}}>{p.label}</span>
                  <span style={{fontSize:10,fontWeight:700,color:p.color,fontFamily:"monospace"}}>
                    {p.val} <span style={{fontSize:8,fontWeight:400,color:"#94a3b8"}}>{p.unit}</span>
                  </span>
                </div>
              ))}
            </div>
          </div>

        </div>
      </div>

      {/* ── Right detail panel — width 268, exact SiloBalanceView ── */}
      <div style={{
        width:268,background:"white",borderLeft:"1px solid #e2e8f0",
        flexShrink:0,overflowY:"auto"
      }}>
        <DetailPanel/>
      </div>
    </div>
  )
}


// ─── Công Nghệ Lò Cao ─────────────────────────────────────

// ── Data ──
const LGN_STOVES = [
  { id:"1H", label:"Lò gió nóng 1", temp:1144, apSuat:9.5,  phamHoi:0.0, caiDat:5.0,   mode:"TĂNG", state:"GIẢM", burning:false, active:true  },
  { id:"2H", label:"Lò gió nóng 2", temp:1221, apSuat:null, phamHoi:0.0, caiDat:192.1, mode:"MO",   state:"DONG", burning:true,  active:true  },
  { id:"3H", label:"Lò gió nóng 3", temp:1212, apSuat:null, phamHoi:0.0, caiDat:-2.0,  mode:"MO",   state:"DONG", burning:true,  active:true  },
  { id:"4H", label:"Lò gió nóng 4", temp:1272, apSuat:null, phamHoi:0.0, caiDat:192.1, mode:"MO",   state:"DONG", burning:false, active:false },
  { id:"5H", label:"Lò gió nóng 5", temp:1260, apSuat:null, phamHoi:0.0, caiDat:192.1, mode:"MO",   state:"DONG", burning:true,  active:true  },
]

const LGN_VALVES = [
  { id:"VT-01", label:"Van Tròn Khí",        icon:"🔄", phamHoi:0.0, caiDat:5.0,   unit:"%", color:"#2563eb", active:true,  mode:"TĂNG/GIẢM" },
  { id:"VG-01", label:"Van Điều Chỉnh Gió 1",icon:"💨", phamHoi:0.0, caiDat:192.1, unit:"%", color:"#22c55e", active:true,  mode:"MO/DONG" },
  { id:"VG-02", label:"Van Điều Chỉnh Gió 2",icon:"💨", phamHoi:0.0, caiDat:-2.0,  unit:"%", color:"#22c55e", active:true,  mode:"MO/DONG" },
  { id:"VG-03", label:"Van Điều Chỉnh Gió 3",icon:"💨", phamHoi:0.0, caiDat:192.1, unit:"%", color:"#22c55e", active:true,  mode:"MO/DONG" },
  { id:"VG-04", label:"Van Điều Chỉnh Gió 4",icon:"💨", phamHoi:0.0, caiDat:192.1, unit:"%", color:"#22c55e", active:false, mode:"MO/DONG" },
  { id:"VG-05", label:"Van Điều Chỉnh Gió 5",icon:"💨", phamHoi:0.0, caiDat:192.1, unit:"%", color:"#22c55e", active:true,  mode:"MO/DONG" },
]

const LGN_OUTPUTS = [
  { id:"OUT-01", label:"Gió nóng → Lò cao",   icon:"💨", flow:1240, unit:"m³/h", color:"#ef4444", active:true  },
  { id:"OUT-02", label:"Khí than → Đốt",      icon:"🔥", flow:6638, unit:"Nm³/h",color:"#f97316", active:true  },
  { id:"OUT-03", label:"Nước làm mát",         icon:"💧", flow:860,  unit:"m³/h", color:"#0ea5e9", active:true  },
  { id:"OUT-04", label:"Khói thải lọc bụi",   icon:"🌫", flow:820,  unit:"Nm³/h",color:"#94a3b8", active:true  },
]

const LGN_FILTER = [
  { key:"Nhiệt độ khí thô",   val:"0.0",   unit:"°C",    alarm:false },
  { key:"Áp suất khí thô",    val:"303.7", unit:"kPa",   alarm:true  },
  { key:"Nhiệt độ khí chính", val:"xxx",   unit:"",      alarm:true  },
  { key:"Áp suất khí chính",  val:"0.0",   unit:"kPa",   alarm:false },
  { key:"Lưu lượng N₂",      val:"308.8", unit:"Nm³/h", alarm:false },
]

// ── ZoneGauge equivalent for stove temperature ──
function StoveGauge({ temp=0, maxTemp=1400, burning=false, alarm=false, width=44, height=72 }) {
  const pct     = Math.min(temp / maxTemp, 1)
  const fillH   = pct * (height - 20)
  const color   = burning ? "#ef4444" : "#f59e0b"
  return (
    <svg viewBox={`0 0 ${width} ${height+10}`}
      style={{width, height:height+10, display:"block"}}>
      {/* Body */}
      <rect x={6} y={4} width={width-12} height={height} rx={4}
        fill="white" stroke={alarm?"#fca5a5":"#e2e8f0"} strokeWidth={1.5}/>
      {/* Alarm threshold */}
      <line x1={6} y1={4+height*0.1} x2={width-6} y2={4+height*0.1}
        stroke="#ef4444" strokeWidth={1} strokeDasharray="3 2" opacity={0.5}/>
      {/* Fill */}
      <clipPath id={`sgclip-${temp}`}>
        <rect x={7} y={4} width={width-14} height={height}/>
      </clipPath>
      <rect x={7} y={4+(height-fillH)} width={width-14} height={fillH}
        rx={2} fill={alarm&&pct>0.9?"#ef4444":color} opacity={0.75}
        clipPath={`url(#sgclip-${temp})`}/>
      {/* Temp text */}
      <text x={width/2} y={4+height/2+5} textAnchor="middle"
        fontSize={9} fontWeight="800" fill={alarm&&pct>0.9?"#ef4444":"#0f172a"}>
        {temp}
      </text>
      {/* Outlet nub */}
      <rect x={width/2-4} y={height+3} width={8} height={8} rx={2} fill="#94a3b8"/>
    </svg>
  )
}

// ── Stove belt (same pattern as SinterBelt) ──
function StoveBelt({ stoves, selectedStove, onStoveClick }) {
  return (
    <div style={{
      background:"white", border:"1px solid #e2e8f0", borderRadius:8,
      padding:"12px 16px", marginBottom:14,
      boxShadow:"0 1px 4px rgba(0,0,0,0.05)"
    }}>
      <div style={{fontSize:11, fontWeight:700, color:"#64748b",
        letterSpacing:1, textTransform:"uppercase", marginBottom:10}}>
        Lò gió nóng — nhấp để chọn
      </div>
      <div style={{display:"flex", gap:6, alignItems:"stretch"}}>
        {/* Hot blast input pipe */}
        <div style={{
          width:28, display:"flex", flexDirection:"column",
          justifyContent:"center", alignItems:"center", gap:2
        }}>
          <div style={{fontSize:8, color:"#2563eb", fontWeight:600, writingMode:"vertical-rl"}}>
            Gió lạnh
          </div>
          <div style={{width:3, flex:1, background:"#2563eb",
            borderRadius:2, opacity:0.5, minHeight:40}}/>
        </div>

        {/* Stove cards */}
        {stoves.map(s => {
          const isSel = selectedStove?.id === s.id
          const pct   = Math.min(s.temp / 1400 * 100, 100)
          const c     = s.burning ? "#ef4444" : "#f59e0b"
          return (
            <div key={s.id}
              onClick={() => onStoveClick(s)}
              style={{
                flex:1, background:isSel?"#eff6ff":s.burning?"#fff7ed":"#f8fafc",
                border:`2px solid ${isSel?"#2563eb":s.burning?"#fca5a5":"#e2e8f0"}`,
                borderRadius:6, padding:"6px 4px", cursor:"pointer",
                textAlign:"center", transition:"all .15s", position:"relative",
                opacity: s.active ? 1 : 0.5,
                boxShadow: isSel ? "0 0 0 3px rgba(37,99,235,.15)" : "none"
              }}>
              {/* Temp */}
              <div style={{
                fontSize:9, fontWeight:800, fontFamily:"monospace",
                color:s.burning?"#ef4444":"#94a3b8", lineHeight:1, marginBottom:4
              }}>{s.temp}°C</div>
              {/* Temp bar (vertical, like ZoneGauge inline) */}
              <div style={{
                height:48, background:"#f1f5f9", borderRadius:3,
                position:"relative", overflow:"hidden", margin:"0 4px 4px"
              }}>
                <div style={{
                  position:"absolute", bottom:0, left:0, right:0,
                  height:`${pct}%`,
                  background:`linear-gradient(to top, ${c}, ${c}88)`,
                  transition:"height .3s", borderRadius:3
                }}/>
                <div style={{
                  position:"absolute", inset:0, display:"flex",
                  alignItems:"center", justifyContent:"center",
                  fontSize:8, fontWeight:700, color:s.active?c:"#94a3b8"
                }}>{s.burning?"🔥":"○"}</div>
              </div>
              {/* ID */}
              <div style={{
                fontSize:10, fontWeight:800, color:isSel?"#2563eb":s.active?"#374151":"#94a3b8"
              }}>{s.id}</div>
              {/* State chip */}
              <div style={{
                fontSize:7, fontWeight:600, marginTop:3,
                color:s.burning?"#dc2626":"#64748b"
              }}>{s.state}</div>
            </div>
          )
        })}

        {/* Hot blast output pipe */}
        <div style={{
          width:28, display:"flex", flexDirection:"column",
          justifyContent:"center", alignItems:"center", gap:2
        }}>
          <div style={{fontSize:8, color:"#ef4444", fontWeight:600, writingMode:"vertical-rl"}}>
            Gió nóng
          </div>
          <div style={{width:3, flex:1, background:"#ef4444",
            borderRadius:2, opacity:0.5, minHeight:40}}/>
        </div>
      </div>

      {/* Connecting pipe below */}
      <div style={{
        marginTop:8, height:4,
        background:"linear-gradient(90deg, #2563eb44, #ef444444)",
        borderRadius:2
      }}/>
    </div>
  )
}

function CongNgheLoCaoView() {
  const [selItem,   setSelItem]   = useState(null) // {type:"stove"|"valve"|"output"|"filter", data}
  const [selStove,  setSelStove]  = useState(null)
  const [hoveredId, setHoveredId] = useState(null)

  const avgTemp   = (LGN_STOVES.filter(s=>s.active).reduce((a,s)=>a+s.temp,0)/LGN_STOVES.filter(s=>s.active).length).toFixed(0)
  const burning   = LGN_STOVES.filter(s=>s.burning).length
  const alarmsN   = LGN_FILTER.filter(f=>f.alarm).length

  // ── exact same helpers as SiloBalanceView / SinteringLineView ──
  const HPipe = ({color="#22c55e", active=true, flow=null, width=28, unit=""}) => (
    <div style={{display:"flex",flexDirection:"column",alignItems:"center",gap:1,flexShrink:0}}>
      <div style={{
        width, height:3,
        background:active?color:"#e2e8f0",
        borderRadius:2, opacity:active?1:0.5,
        boxShadow:active?`0 0 4px ${color}66`:"none",
        transition:"all .2s"
      }}/>
      {flow!=null && (
        <span style={{fontSize:7,color:active?color:"#94a3b8",fontWeight:600,whiteSpace:"nowrap"}}>
          {flow>0?`+${flow}`:flow} {unit}
        </span>
      )}
    </div>
  )

  const Arrow = ({color="#22c55e", active=true, dir="right"}) => (
    <span style={{
      fontSize:10, color:active?color:"#e2e8f0",
      flexShrink:0, lineHeight:1,
      filter:active?`drop-shadow(0 0 2px ${color}88)`:"none"
    }}>{dir==="right"?"▶":"◀"}</span>
  )

  const ColHeader = ({title, count, extra=null}) => (
    <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",marginBottom:12}}>
      <span style={{fontSize:11,fontWeight:700,color:"#64748b",letterSpacing:1,textTransform:"uppercase"}}>
        {title} <span style={{fontWeight:400,fontSize:10,color:"#94a3b8"}}>({count})</span>
      </span>
      {extra || (
        <button style={{
          width:22,height:22,borderRadius:"50%",background:"#22c55e",border:"none",
          cursor:"pointer",fontSize:14,color:"white",
          display:"flex",alignItems:"center",justifyContent:"center",
          boxShadow:"0 1px 4px rgba(34,197,94,.4)",flexShrink:0
        }}>+</button>
      )}
    </div>
  )

  // ── Valve card — same pattern as InputCard / FlowCard ──
  const ValveCard = ({item}) => {
    const isSel = selItem?.data?.id===item.id
    const isHov = hoveredId===item.id
    return (
      <div
        onClick={()=>setSelItem(isSel?null:{type:"valve",data:item})}
        onMouseEnter={()=>setHoveredId(item.id)}
        onMouseLeave={()=>setHoveredId(null)}
        style={{
          background:"white",
          border:`2px solid ${isSel?"#2563eb":item.active?"#e2e8f0":"#f1f5f9"}`,
          borderRadius:8,padding:"10px 12px",cursor:"pointer",marginBottom:8,
          boxShadow:isSel?"0 0 0 3px rgba(37,99,235,.15)":isHov?"0 2px 8px rgba(0,0,0,0.08)":"none",
          transition:"all .15s",opacity:item.active?1:0.6
        }}>
        <div style={{display:"flex",alignItems:"center",gap:6,marginBottom:6}}>
          <span style={{fontSize:16}}>{item.icon}</span>
          <div style={{flex:1}}>
            <div style={{fontSize:11,fontWeight:700,color:"#374151"}}>{item.label}</div>
            <div style={{fontSize:9,fontFamily:"monospace",color:"#94a3b8"}}>{item.id}</div>
          </div>
          <span style={{
            fontSize:9,background:item.active?"#dcfce7":"#fee2e2",
            color:item.active?"#16a34a":"#dc2626",
            padding:"1px 6px",borderRadius:8,fontWeight:600
          }}>{item.active?"Đang chạy":"Dừng"}</span>
        </div>
        {/* Flow row with mini SVG node — exact same as FlowCard */}
        <div style={{display:"flex",alignItems:"center",gap:4}}>
          <div style={{width:14,height:3,background:item.active?item.color:"#e2e8f0",borderRadius:2}}/>
          <svg viewBox="0 0 28 18" style={{width:28,height:18,flexShrink:0}}>
            <rect x={1} y={2} width={12} height={14} rx={2} fill="white"
              stroke={item.active?item.color:"#e2e8f0"} strokeWidth={1.5}/>
            <circle cx={7} cy={9} r={3} fill={item.active?item.color:"#e2e8f0"} opacity={0.3}/>
            <circle cx={7} cy={9} r={1.5} fill={item.active?item.color:"#e2e8f0"}/>
            <line x1={13} y1={9} x2={18} y2={9}
              stroke={item.active?item.color:"#e2e8f0"} strokeWidth={1.5}/>
            <rect x={18} y={2} width={9} height={14} rx={2} fill="white"
              stroke={item.active?item.color:"#e2e8f0"} strokeWidth={1.5}/>
          </svg>
          <div style={{width:6,height:3,background:item.active?item.color:"#e2e8f0",borderRadius:2}}/>
          <Arrow color={item.color} active={item.active} dir="right"/>
          <div style={{flex:1,textAlign:"right"}}>
            <span style={{fontSize:11,fontWeight:800,
              color:item.active?item.color:"#94a3b8",fontFamily:"monospace"}}>
              {item.caiDat}
            </span>
            <span style={{fontSize:9,color:"#94a3b8",marginLeft:2}}>{item.unit}</span>
          </div>
        </div>
        <div style={{marginTop:4,fontSize:9,color:"#64748b"}}>
          Phám Hồi : <span style={{fontWeight:600,fontFamily:"monospace",color:"#374151"}}>
            {item.phamHoi} {item.unit}
          </span>
          <span style={{marginLeft:8,color:"#94a3b8"}}>{item.mode}</span>
        </div>
      </div>
    )
  }

  // ── Stove card (center col) — same style as MachineCard ──
  const StoveCard = ({s}) => {
    const isSel = selItem?.data?.id===s.id || selStove?.id===s.id
    const isHov = hoveredId===s.id
    const pct   = Math.min(s.temp/1400*100,100)
    const c     = s.burning?"#ef4444":"#f59e0b"
    return (
      <div
        onClick={()=>{
          const val = isSel?null:{type:"stove",data:s}
          setSelItem(val)
          setSelStove(isSel?null:s)
        }}
        onMouseEnter={()=>setHoveredId(s.id)}
        onMouseLeave={()=>setHoveredId(null)}
        style={{
          background:"white",
          border:`2px solid ${isSel?"#2563eb":s.active?"#e2e8f0":"#fca5a5"}`,
          borderRadius:8,padding:"12px",cursor:"pointer",marginBottom:8,
          boxShadow:isSel?"0 0 0 3px rgba(37,99,235,.15)":isHov?"0 2px 8px rgba(0,0,0,0.08)":"none",
          transition:"all .15s", opacity:s.active?1:0.6
        }}>
        <div style={{display:"flex",alignItems:"center",gap:8,marginBottom:10}}>
          <div style={{
            width:34,height:34,borderRadius:6,
            background:s.burning?"#1e293b":"#f1f5f9",
            display:"flex",alignItems:"center",justifyContent:"center",
            fontSize:18,flexShrink:0
          }}>{s.burning?"🔥":"○"}</div>
          <div style={{flex:1}}>
            <div style={{fontSize:11,fontWeight:700,color:"#374151"}}>{s.label}</div>
            <div style={{fontSize:9,fontFamily:"monospace",color:"#94a3b8"}}>{s.id}</div>
          </div>
          <span style={{
            fontSize:9,
            background:s.burning?"#fee2e2":s.active?"#fff7ed":"#fee2e2",
            color:s.burning?"#dc2626":s.active?"#92400e":"#dc2626",
            padding:"1px 6px",borderRadius:8,fontWeight:600
          }}>{s.burning?"Đốt":s.active?"Dự trữ":"Dừng"}</span>
        </div>
        {/* Temp + setpoint row — same as speed/setpoint in MachineCard */}
        <div style={{display:"flex",gap:10,marginBottom:8}}>
          <div style={{flex:1}}>
            <div style={{fontSize:9,color:"#94a3b8",marginBottom:1}}>Nhiệt độ</div>
            <div style={{fontSize:20,fontWeight:900,color:c,lineHeight:1,fontFamily:"monospace"}}>
              {s.temp}<span style={{fontSize:10,fontWeight:400,color:"#94a3b8",marginLeft:2}}>°C</span>
            </div>
          </div>
          <div style={{flex:1}}>
            <div style={{fontSize:9,color:"#94a3b8",marginBottom:1}}>Cài Đặt</div>
            <div style={{fontSize:14,fontWeight:700,color:"#64748b",lineHeight:1,fontFamily:"monospace"}}>
              {s.caiDat}<span style={{fontSize:9,fontWeight:400,color:"#94a3b8",marginLeft:2}}>%</span>
            </div>
            <div style={{fontSize:8,marginTop:1,color:Math.abs(s.phamHoi-s.caiDat)<5?"#22c55e":"#f59e0b"}}>
              Δ {Math.abs(s.phamHoi-s.caiDat).toFixed(1)} %
            </div>
          </div>
        </div>
        {/* Progress bar */}
        <div style={{height:5,background:"#f1f5f9",borderRadius:3,overflow:"hidden",marginBottom:6}}>
          <div style={{
            height:"100%",borderRadius:3,transition:"width .3s",
            width:`${Math.min(pct,100)}%`,
            background:pct>95?"#ef4444":pct>80?"#f59e0b":"#22c55e"
          }}/>
        </div>
        {/* State + pressure */}
        <div style={{display:"flex",gap:4,flexWrap:"wrap"}}>
          {[
            {k:"Mode",   v:s.mode},
            {k:"Van",    v:s.state},
            ...(s.apSuat?[{k:"AS",v:`${s.apSuat} kPa`}]:[])
          ].map(r=>(
            <div key={r.k} style={{
              background:"#f8fafc",border:"1px solid #e2e8f0",
              borderRadius:4,padding:"2px 6px",fontSize:8
            }}>
              <span style={{color:"#94a3b8"}}>{r.k}: </span>
              <span style={{color:"#374151",fontWeight:600,fontFamily:"monospace"}}>{r.v}</span>
            </div>
          ))}
        </div>
      </div>
    )
  }

  // ── Output card — same pattern as OutputCard in SinteringLineView ──
  const OutputCard = ({item}) => {
    const isSel = selItem?.data?.id===item.id
    const isHov = hoveredId===item.id
    return (
      <div
        onClick={()=>setSelItem(isSel?null:{type:"output",data:item})}
        onMouseEnter={()=>setHoveredId(item.id)}
        onMouseLeave={()=>setHoveredId(null)}
        style={{
          background:"white",
          border:`2px solid ${isSel?"#2563eb":item.active?"#e2e8f0":"#f1f5f9"}`,
          borderRadius:8,padding:"10px 12px",cursor:"pointer",marginBottom:8,
          boxShadow:isSel?"0 0 0 3px rgba(37,99,235,.15)":isHov?"0 2px 8px rgba(0,0,0,0.08)":"none",
          transition:"all .15s",opacity:item.active?1:0.6
        }}>
        <div style={{display:"flex",alignItems:"center",gap:6,marginBottom:6}}>
          <span style={{fontSize:16}}>{item.icon}</span>
          <div style={{flex:1}}>
            <div style={{fontSize:11,fontWeight:700,color:"#374151"}}>{item.label}</div>
            <div style={{fontSize:9,fontFamily:"monospace",color:"#94a3b8"}}>{item.id}</div>
          </div>
          {!item.active&&<span style={{
            fontSize:9,background:"#fee2e2",color:"#dc2626",
            padding:"1px 6px",borderRadius:8,fontWeight:600
          }}>Dừng</span>}
        </div>
        {/* Exact OutputCard flow row pattern */}
        <div style={{display:"flex",alignItems:"center",gap:4}}>
          <Arrow color={item.color} active={item.active} dir="left"/>
          <div style={{width:6,height:3,background:item.active?item.color:"#e2e8f0",borderRadius:2}}/>
          <svg viewBox="0 0 28 18" style={{width:28,height:18,flexShrink:0}}>
            <rect x={1} y={2} width={12} height={14} rx={2} fill="white"
              stroke={item.active?item.color:"#e2e8f0"} strokeWidth={1.5}/>
            <circle cx={7} cy={9} r={3} fill={item.active?item.color:"#e2e8f0"} opacity={0.3}/>
            <circle cx={7} cy={9} r={1.5} fill={item.active?item.color:"#e2e8f0"}/>
            <line x1={13} y1={9} x2={18} y2={9}
              stroke={item.active?item.color:"#e2e8f0"} strokeWidth={1.5}/>
            <rect x={18} y={2} width={9} height={14} rx={2} fill="white"
              stroke={item.active?item.color:"#e2e8f0"} strokeWidth={1.5}/>
          </svg>
          <div style={{width:8,height:3,background:item.active?item.color:"#e2e8f0",borderRadius:2}}/>
          <div style={{flex:1,textAlign:"right"}}>
            <span style={{fontSize:13,fontWeight:800,
              color:item.active?item.color:"#94a3b8",fontFamily:"monospace"}}>
              {item.flow}
            </span>
            <span style={{fontSize:9,color:"#94a3b8",marginLeft:2}}>{item.unit}</span>
          </div>
        </div>
      </div>
    )
  }

  // ── Detail panel — same structure as SinteringLineView DetailPanel ──
  const DetailPanel = () => {
    if (!selItem && !selStove) return (
      <div style={{
        height:"100%",display:"flex",flexDirection:"column",
        alignItems:"center",justifyContent:"center",
        color:"#94a3b8",fontSize:12,padding:20,textAlign:"center",gap:8
      }}>
        <span style={{fontSize:32}}>⚙</span>
        <span style={{fontWeight:600,color:"#64748b"}}>Chọn một phần tử</span>
        <span style={{fontSize:11,color:"#cbd5e1",lineHeight:1.5}}>
          Nhấp vào lò gió nóng, van hoặc đầu ra để xem thông tin
        </span>
      </div>
    )

    // Stove detail — like zone detail with gauge
    if (selStove && selItem?.type==="stove") {
      const s   = selStove
      const pct = Math.min(s.temp/1400*100, 100)
      const c   = s.burning?"#ef4444":"#f59e0b"
      const trend = Array.from({length:18},(_,i)=>
        Math.max(5, Math.min(95, pct + Math.sin(i/2)*12 + (Math.random()-.5)*6))
      )
      return (
        <div>
          <div style={{padding:"10px 14px",background:"#f8fafc",borderBottom:"1px solid #e2e8f0",
            display:"flex",alignItems:"center",justifyContent:"space-between"}}>
            <div>
              <span style={{fontSize:9,color:"#94a3b8",fontFamily:"monospace"}}>{s.id} · </span>
              <span style={{fontSize:12,fontWeight:700,color:"#0f172a"}}>{s.label}</span>
            </div>
            <button style={{background:"none",border:"none",cursor:"pointer",color:"#94a3b8",fontSize:16}}>⋯</button>
          </div>
          <div style={{display:"flex",borderBottom:"1px solid #f1f5f9"}}>
            {["Thông tin","Cảnh báo"].map((t,i)=>(
              <button key={t} style={{padding:"8px 12px",border:"none",cursor:"pointer",fontSize:11,
                fontWeight:i===0?700:400,color:i===0?"#2563eb":"#94a3b8",
                borderBottom:i===0?"2px solid #2563eb":"2px solid transparent",
                background:"none"}}>{t}</button>
            ))}
          </div>
          {/* Gauge + live temp */}
          <div style={{padding:"10px 14px",display:"flex",gap:10,alignItems:"center",
            background:"white",borderBottom:"1px solid #f1f5f9"}}>
            <StoveGauge temp={s.temp} burning={s.burning} width={44} height={72}/>
            <div style={{flex:1}}>
              <div style={{fontSize:22,fontWeight:800,color:c,lineHeight:1,fontFamily:"monospace"}}>
                {s.temp}
                <span style={{fontSize:12,fontWeight:400,color:"#94a3b8",marginLeft:4}}>°C</span>
              </div>
              <div style={{fontSize:10,color:"#64748b",marginTop:3}}>Max : 1 400 °C</div>
              <div style={{
                marginTop:6,display:"inline-flex",alignItems:"center",gap:4,
                background:s.burning?"#fee2e2":s.active?"#fff7ed":"#f1f5f9",
                color:s.burning?"#dc2626":s.active?"#92400e":"#64748b",
                padding:"2px 8px",borderRadius:10,fontSize:9,fontWeight:600
              }}>
                {s.burning?"🔥 Đốt":s.active?"○ Dự trữ":"■ Dừng"}
              </div>
            </div>
          </div>
          {/* Fields */}
          {[
            ["Nhiệt độ",  `${s.temp} °C`],
            ["Áp suất",   s.apSuat!=null?`${s.apSuat} kPa`:"—"],
            ["Phám Hồi",  `${s.phamHoi} %`],
            ["Cài Đặt",   `${s.caiDat} %`],
            ["Mode Van",  s.mode],
            ["Trạng thái",s.state],
          ].map(([k,v])=>(
            <div key={k} style={{display:"flex",justifyContent:"space-between",
              padding:"7px 14px",borderBottom:"1px solid #f8fafc"}}>
              <span style={{fontSize:11,color:"#94a3b8"}}>{k}</span>
              <span style={{fontSize:11,fontWeight:600,
                color:k==="Trạng thái"&&!s.active?"#dc2626":"#0f172a"}}>{v}</span>
            </div>
          ))}
          {/* Trend */}
          <div style={{padding:"8px 14px 2px",fontSize:9,fontWeight:700,
            color:"#94a3b8",letterSpacing:1,background:"#f8fafc",marginTop:4}}>24H QUA</div>
          <div style={{padding:"6px 14px 14px",background:"#f8fafc"}}>
            <div style={{display:"flex",alignItems:"flex-end",gap:1,height:44}}>
              {trend.map((v,i)=>(
                <div key={i} style={{flex:1,height:`${v}%`,
                  background:c,borderRadius:"1px 1px 0 0",opacity:0.8}}/>
              ))}
            </div>
            <div style={{display:"flex",justifyContent:"space-between",marginTop:2}}>
              <span style={{fontSize:7,color:"#94a3b8"}}>-24h</span>
              <span style={{fontSize:7,color:"#94a3b8"}}>hiện tại</span>
            </div>
          </div>
        </div>
      )
    }

    // Valve / output detail — same as SinteringLineView machine/flow detail
    const item    = selItem.data
    const isAlarm = !item.active
    const trend   = Array.from({length:18},(_,i)=>
      30+Math.abs(Math.sin(i/3))*50+(Math.random()-.5)*8
    )
    const fields = selItem.type==="valve" ? [
      ["Phám Hồi", `${item.phamHoi} ${item.unit}`],
      ["Cài Đặt",  `${item.caiDat} ${item.unit}`],
      ["Sai lệch", `Δ ${Math.abs(item.phamHoi-item.caiDat).toFixed(1)} ${item.unit}`],
      ["Mode",     item.mode],
      ["Trạng thái",item.active?"Đang chạy":"Dừng"],
    ] : [
      ["Lưu lượng", `${item.flow} ${item.unit}`],
      ["Hướng",     "◀ Ra"],
      ["Trạng thái",item.active?"Hoạt động":"Dừng"],
    ]
    return (
      <div>
        <div style={{padding:"10px 14px",background:"#f8fafc",borderBottom:"1px solid #e2e8f0",
          display:"flex",alignItems:"center",justifyContent:"space-between"}}>
          <div>
            <span style={{fontSize:9,color:"#94a3b8",fontFamily:"monospace"}}>{item.id} · </span>
            <span style={{fontSize:12,fontWeight:700,color:"#0f172a"}}>{item.label}</span>
          </div>
          <button style={{background:"none",border:"none",cursor:"pointer",color:"#94a3b8",fontSize:16}}>⋯</button>
        </div>
        <div style={{display:"flex",borderBottom:"1px solid #f1f5f9"}}>
          {["Thông tin","Lịch sử"].map((t,i)=>(
            <button key={t} style={{padding:"8px 12px",border:"none",cursor:"pointer",fontSize:11,
              fontWeight:i===0?700:400,color:i===0?"#2563eb":"#94a3b8",
              borderBottom:i===0?"2px solid #2563eb":"2px solid transparent",
              background:"none"}}>{t}</button>
          ))}
        </div>
        {fields.map(([k,v])=>(
          <div key={k} style={{display:"flex",justifyContent:"space-between",
            padding:"7px 14px",borderBottom:"1px solid #f8fafc"}}>
            <span style={{fontSize:11,color:"#94a3b8"}}>{k}</span>
            <span style={{fontSize:11,fontWeight:600,
              color:k==="Trạng thái"?isAlarm?"#dc2626":"#16a34a":"#0f172a"}}>{v}</span>
          </div>
        ))}
        <div style={{padding:"8px 14px 2px",fontSize:9,fontWeight:700,
          color:"#94a3b8",letterSpacing:1,background:"#f8fafc",marginTop:4}}>GIỜ VỪA QUA</div>
        <div style={{padding:"6px 14px 14px",background:"#f8fafc"}}>
          <div style={{display:"flex",alignItems:"flex-end",gap:1,height:44}}>
            {trend.map((v,i)=>(
              <div key={i} style={{flex:1,height:`${v}%`,
                background:item.color||"#2563eb",
                borderRadius:"1px 1px 0 0",opacity:0.8}}/>
            ))}
          </div>
          <div style={{display:"flex",justifyContent:"space-between",marginTop:2}}>
            <span style={{fontSize:7,color:"#94a3b8"}}>-1h</span>
            <span style={{fontSize:7,color:"#94a3b8"}}>hiện tại</span>
          </div>
        </div>
      </div>
    )
  }

  return (
    <div style={{flex:1,display:"flex",overflow:"hidden"}}>

      {/* ── Main canvas ── */}
      <div style={{flex:1,overflow:"auto",padding:"14px 16px"}}>

        {/* KPI strip — identical pattern to all other views */}
        <div style={{display:"flex",gap:8,marginBottom:14,flexWrap:"wrap"}}>
          {[
            {label:"Temp. moy. lò",      value:`${avgTemp} °C`,    icon:"🌡", color:"#ef4444"},
            {label:"Lò đang đốt",        value:`${burning}/${LGN_STOVES.length}`, icon:"🔥", color:"#f97316"},
            {label:"Áp suất gió lạnh",   value:"174.0 kPa",        icon:"💨", color:"#2563eb"},
            {label:"Cảnh báo lọc bụi",   value:`${alarmsN}`,       icon:"⚠",  color:alarmsN>0?"#ef4444":"#22c55e"},
          ].map(k=>(
            <div key={k.label} style={{
              background:"white",border:"1px solid #e2e8f0",borderRadius:8,
              padding:"8px 12px",display:"flex",alignItems:"center",gap:8,
              flex:1,minWidth:110,boxShadow:"0 1px 3px rgba(0,0,0,0.04)"
            }}>
              <span style={{fontSize:18}}>{k.icon}</span>
              <div>
                <div style={{fontSize:15,fontWeight:800,color:k.color,lineHeight:1}}>{k.value}</div>
                <div style={{fontSize:9,color:"#94a3b8",marginTop:1}}>{k.label}</div>
              </div>
            </div>
          ))}
        </div>

        {/* StoveBelt — clickable stove row, same concept as SinterBelt */}
        <StoveBelt
          stoves={LGN_STOVES}
          selectedStove={selStove}
          onStoveClick={s=>{
            const same = selStove?.id===s.id
            setSelStove(same?null:s)
            setSelItem(same?null:{type:"stove",data:s})
          }}
        />

        {/* 3-column layout */}
        <div style={{display:"flex",gap:0,minWidth:540}}>

          {/* ── Col 1: Van điều chỉnh ── */}
          <div style={{flex:1,borderRight:"1px solid #e2e8f0",paddingRight:12,minWidth:160}}>
            <ColHeader title="Van điều chỉnh" count={LGN_VALVES.length}/>
            {LGN_VALVES.map(v=><ValveCard key={v.id} item={v}/>)}
            {/* HPipe linking col1 → col2 */}
            <div style={{display:"flex",alignItems:"center",justifyContent:"flex-end",
              marginTop:8}}>
              <HPipe color="#2563eb" active={true} flow={1240} width={32} unit="m³/h"/>
              <Arrow color="#2563eb" active={true} dir="right"/>
            </div>
          </div>

          {/* ── Col 2: Lò gió nóng ── */}
          <div style={{flex:1.2,borderRight:"1px solid #e2e8f0",padding:"0 12px",minWidth:180}}>
            <ColHeader title="Lò gió nóng" count={LGN_STOVES.length}/>
            {LGN_STOVES.map(s=><StoveCard key={s.id} s={s}/>)}
          </div>

          {/* ── Col 3: Đầu ra + lọc bụi ── */}
          <div style={{flex:1,paddingLeft:12,minWidth:160}}>
            <div style={{display:"flex",alignItems:"center",marginBottom:12}}>
              <Arrow color="#ef4444" active={true} dir="left"/>
              <HPipe color="#ef4444" active={true} width={16}/>
              <div style={{flex:1}}>
                <ColHeader title="Đầu ra" count={LGN_OUTPUTS.length}/>
              </div>
            </div>
            {LGN_OUTPUTS.map(o=><OutputCard key={o.id} item={o}/>)}

            {/* Lọc bụi thổi vải card — same inline param card style */}
            <div style={{
              background:"white",border:"1px solid #e2e8f0",borderRadius:8,
              padding:"10px 12px",marginTop:4,
              boxShadow:"0 1px 3px rgba(0,0,0,0.04)"
            }}>
              <div style={{fontSize:10,fontWeight:700,color:"#374151",marginBottom:8,
                display:"flex",alignItems:"center",gap:6}}>
                Thông Số Lọc Bụi Thổi Vải
                {LGN_FILTER.some(f=>f.alarm) && (
                  <span style={{width:16,height:16,borderRadius:"50%",background:"#ef4444",
                    display:"inline-flex",alignItems:"center",justifyContent:"center",
                    fontSize:8,color:"white",fontWeight:900}}>!</span>
                )}
              </div>
              {LGN_FILTER.map(p=>(
                <div key={p.key} style={{
                  display:"flex",alignItems:"center",justifyContent:"space-between",
                  padding:"5px 0",borderBottom:"1px solid #f8fafc"
                }}>
                  <span style={{fontSize:10,color:"#64748b"}}>{p.key}</span>
                  <div style={{display:"flex",alignItems:"baseline",gap:3}}>
                    <span style={{
                      fontSize:13,fontWeight:800,fontFamily:"monospace",
                      color:p.alarm?"#ef4444":"#0f172a",
                      background:p.alarm?"#fee2e2":"transparent",
                      padding:p.alarm?"1px 4px":"0",borderRadius:3
                    }}>{p.val}</span>
                    {p.unit&&<span style={{fontSize:9,color:"#94a3b8"}}>{p.unit}</span>}
                  </div>
                </div>
              ))}
            </div>
          </div>

        </div>
      </div>

      {/* ── Right detail panel — 268px, exact same as all other views ── */}
      <div style={{
        width:268,background:"white",borderLeft:"1px solid #e2e8f0",
        flexShrink:0,overflowY:"auto"
      }}>
        <DetailPanel/>
      </div>
    </div>
  )
}


// ─── Giám Sát Lò Cao ─────────────────────────────────────

// ── Data ──
const GS_TEMPS_LEFT = [
  { key:"Nhiệt độ đỉnh Bắc", val:118, alarm:false },
  { key:"Nhiệt độ đỉnh Nam",  val:102, alarm:false },
  { key:"Nhiệt độ trên Bắc",  val:307, alarm:true  },
  { key:"Nhiệt độ trên Nam",   val:301, alarm:true  },
  { key:"Nhiệt độ giữa Bắc",  val:389, alarm:true  },
  { key:"Nhiệt độ giữa Nam",   val:370, alarm:true  },
  { key:"Nhiệt độ dưới Bắc",  val:310, alarm:false },
  { key:"Nhiệt độ dưới Nam",   val:318, alarm:false },
  { key:"Nhiệt độ đáy",        val:104, alarm:false },
  { key:"Nhiệt độ đáy lò",     val:97,  alarm:false },
]

const GS_PARAMS_TOP = [
  { key:"Áp suất đỉnh lò", val:"37",   unit:"kPa", alarm:false, sub:"35" },
  { key:"Lưu lượng cấp nước",val:"0",  unit:"",    alarm:false },
  { key:"Lưu lượng hồi nước",val:"0",  unit:"",    alarm:false },
  { key:"Nhiệt độ nước cấp", val:"0",  unit:"°C",  alarm:false },
  { key:"Độ nghiêng trái",   val:"1.52",unit:"m",  alarm:false },
  { key:"Độ nghiêng phải",   val:"1.52",unit:"m",  alarm:false },
  { key:"Áp suất gió nóng",  val:"143.1",unit:"kPa",alarm:false},
  { key:"Nhiệt độ gió nóng", val:"136.5",unit:"°C", alarm:false},
  { key:"Lưu lượng gió lạnh",val:"453",unit:"m³/h",alarm:false},
  { key:"Chênh lệch áp toàn",val:"99.4",unit:"kPa",alarm:false},
  { key:"Lượng oxy giàu",    val:"1 350",unit:"m³/h",alarm:false},
]

const GS_HOT_STOVES = [
  { id:"HS1", tempTop:1123, tempBot:168, active:true,  burning:false, color:"#f59e0b" },
  { id:"HS2", tempTop:1200, tempBot:266, active:true,  burning:true,  color:"#ef4444" },
  { id:"HS3", tempTop:157,  tempBot:202, active:true,  burning:false, color:"#94a3b8" },
]

const GS_PRESSURE_VALVES = [
  { id:"PV-1", label:"Bình 1", val:0.0, unit:"kPa", open:true  },
  { id:"PV-2", label:"Bình 2", val:0.0, unit:"kPa", open:false },
]

// Generate trend data for multi-line chart
function genTrend(base, noise, n=60) {
  return Array.from({length:n},(_,i)=>
    Math.max(0, base + Math.sin(i/8)*noise*0.5 + (Math.random()-.5)*noise)
  )
}
const GS_TREND_SERIES = [
  { id:"topTemp",  label:"Nhiệt độ đỉnh",  color:"#22c55e",  data:genTrend(118, 15) },
  { id:"midTemp",  label:"Nhiệt độ giữa",  color:"#ef4444",  data:genTrend(380, 25) },
  { id:"hotWind",  label:"Gió nóng",       color:"#f59e0b",  data:genTrend(143, 8)  },
  { id:"coldFlow", label:"Gió lạnh",       color:"#0ea5e9",  data:genTrend(453, 30) },
  { id:"pressure", label:"Áp suất đỉnh",   color:"#a855f7",  data:genTrend(37,  3)  },
  { id:"oxygen",   label:"Oxy giàu",       color:"#ec4899",  data:genTrend(9,   1.5),scale:10 },
]

// ── Furnace cross-section SVG — matches SCADA layout ──
function FurnaceCrossSection({ width=140, height=220, topLeft=118, topRight=102, running=true }) {
  const cx = width/2
  const c  = running ? "#1e3a5f" : "#94a3b8"
  const fc = running ? "#dbeafe" : "#f1f5f9"
  return (
    <svg viewBox={`0 0 ${width} ${height}`} style={{width,height,display:"block"}}>
      {/* ── Outer furnace body ── */}
      {/* Stack top */}
      <rect x={cx-22} y={2} width={44} height={34} rx={3}
        fill={fc} stroke={c} strokeWidth={1.5}/>
      {/* Bell (throat) */}
      <path d={`M ${cx-18},36 Q ${cx-18},46 ${cx},46 Q ${cx+18},46 ${cx+18},36 Z`}
        fill={running?"#fde68a":"#e2e8f0"} stroke={c} strokeWidth={1}/>
      {/* Shaft */}
      <polygon points={`${cx-20},46 ${cx+20},46 ${cx+28},110 ${cx-28},110`}
        fill={fc} stroke={c} strokeWidth={1.5}/>
      {/* Belly */}
      <rect x={cx-28} y={110} width={56} height={22} rx={1}
        fill={running?"#fca5a5":"#e2e8f0"} stroke={c} strokeWidth={1.5}/>
      {/* Bosh */}
      <polygon points={`${cx-28},132 ${cx+28},132 ${cx+20},168 ${cx-20},168`}
        fill={fc} stroke={c} strokeWidth={1.5}/>
      {/* Hearth */}
      <rect x={cx-20} y={168} width={40} height={24} rx={2}
        fill={running?"#ef4444":"#cbd5e1"} stroke={c} strokeWidth={1.5}/>
      {/* Tuyères left */}
      {[140,150,160].map((y,i)=>(
        <g key={i}>
          <rect x={cx-36} y={y} width={10} height={6} rx={2} fill={running?"#2563eb":"#e2e8f0"}/>
          <rect x={cx+26} y={y} width={10} height={6} rx={2} fill={running?"#2563eb":"#e2e8f0"}/>
        </g>
      ))}
      {/* Hot blast pipes — left */}
      <path d={`M ${cx-46},155 L ${cx-36},155`}
        stroke="#2563eb" strokeWidth={3} fill="none"/>
      <path d={`M ${cx-46},140 L ${cx-46},170`}
        stroke="#2563eb" strokeWidth={3} fill="none"/>
      {/* Hot blast pipes — right */}
      <path d={`M ${cx+36},155 L ${cx+46},155`}
        stroke="#2563eb" strokeWidth={3} fill="none"/>
      <path d={`M ${cx+46},140 L ${cx+46},170`}
        stroke="#2563eb" strokeWidth={3} fill="none"/>
      {/* Tap hole */}
      <rect x={cx-6} y={190} width={12} height={4} rx={1}
        fill={running?"#f97316":"#94a3b8"}/>
      {/* Gas outlet pipes from top */}
      <line x1={cx} y1={2} x2={cx} y2={-4} stroke="#22c55e" strokeWidth={2}/>
      <polygon points={`${cx-4},-4 ${cx+4},-4 ${cx},−10`} fill="#22c55e"/>
      {/* ── Thước đo (probe rulers) ── */}
      {/* Left probe — red triangle */}
      <polygon points={`${cx-14},68 ${cx-4},56 ${cx-4},80`}
        fill="#ef4444" opacity={0.9}/>
      {/* Right probe */}
      <polygon points={`${cx+14},68 ${cx+4},56 ${cx+4},80`}
        fill="#ef4444" opacity={0.9}/>
      {/* Probe dimension arrows */}
      <line x1={cx-14} y1={85} x2={cx+14} y2={85} stroke="#1e3a5f" strokeWidth={1}/>
      <text x={cx} y={95} textAnchor="middle" fontSize={8} fontWeight="700" fill="#1e3a5f">
        2.31m
      </text>
      <line x1={cx-8} y1={100} x2={cx+8} y2={100} stroke="#64748b" strokeWidth={1}/>
      <text x={cx} y={108} textAnchor="middle" fontSize={7} fill="#64748b">1.82m</text>
      {/* Status badge */}
      <rect x={cx-24} y={200} width={48} height={14} rx={3}
        fill={running?"#dcfce7":"#fee2e2"} stroke={running?"#22c55e":"#ef4444"} strokeWidth={1}/>
      <text x={cx} y={210} textAnchor="middle" fontSize={8} fontWeight="700"
        fill={running?"#16a34a":"#dc2626"}>
        {running?"Bình thường":"Dừng"}
      </text>
      {/* Top temp labels */}
      <text x={8} y={12} fontSize={7} fontWeight="700" fill="#374151">{topLeft}°</text>
      <text x={width-8} y={12} textAnchor="end" fontSize={7} fontWeight="700" fill="#374151">{topRight}°</text>
      {/* Zone labels */}
      <text x={cx} y={18} textAnchor="middle" fontSize={7} fill="#1e3a5f" fontWeight="700">ĐỈNH</text>
      <text x={cx} y={78} textAnchor="middle" fontSize={7} fill="#374151">THÂN</text>
      <text x={cx} y={120} textAnchor="middle" fontSize={6} fill="#991b1b">BELLY</text>
      <text x={cx} y={152} textAnchor="middle" fontSize={7} fill="#374151">BOSH</text>
    </svg>
  )
}

// ── Inline mini sparkline ──
function Sparkline({ data, color="#2563eb", width=80, height=28 }) {
  if (!data || data.length < 2) return null
  const mn = Math.min(...data), mx = Math.max(...data)
  const range = mx-mn || 1
  const pts = data.map((v,i)=>{
    const x = (i/(data.length-1))*width
    const y = height - ((v-mn)/range)*(height-4) - 2
    return `${x},${y}`
  }).join(' ')
  return (
    <svg viewBox={`0 0 ${width} ${height}`} style={{width,height,display:"block",flexShrink:0}}>
      <polyline points={pts} fill="none" stroke={color} strokeWidth={1.5} strokeLinejoin="round"/>
      {/* Last point dot */}
      {(() => {
        const last = data[data.length-1]
        const x = width
        const y = height - ((last-mn)/range)*(height-4) - 2
        return <circle cx={x} cy={y} r={2.5} fill={color}/>
      })()}
    </svg>
  )
}

// ── Multi-line trend chart using SVG (no dependency) ──
function TrendChart({ series, width="100%", height=180 }) {
  const N   = series[0]?.data?.length || 60
  const W   = 600, H = 160, PAD = { l:40, r:16, t:10, b:24 }
  const IW  = W - PAD.l - PAD.r
  const IH  = H - PAD.t - PAD.b
  // Normalize each series 0-1 for display on shared axis
  const paths = series.map(s => {
    const mn = Math.min(...s.data), mx = Math.max(...s.data)
    const range = mx-mn || 1
    const pts = s.data.map((v,i) => {
      const x = PAD.l + (i/(N-1))*IW
      const y = PAD.t + IH - ((v-mn)/range)*IH
      return `${x.toFixed(1)},${y.toFixed(1)}`
    }).join(' ')
    return { ...s, pts, mn, mx }
  })
  // X-axis labels
  const xLabels = Array.from({length:7},(_,i)=>{
    const h = 16 + Math.floor(i*58/6)
    return `${String(h).padStart(2,"0")}:00`
  })
  return (
    <div style={{width,overflowX:"auto"}}>
      <svg viewBox={`0 0 ${W} ${H}`} style={{width:"100%",height,display:"block"}}>
        {/* Grid lines */}
        {[0,.25,.5,.75,1].map((f,i)=>(
          <line key={i}
            x1={PAD.l} y1={PAD.t+IH*f}
            x2={PAD.l+IW} y2={PAD.t+IH*f}
            stroke="#f1f5f9" strokeWidth={1}/>
        ))}
        {/* Data lines */}
        {paths.map(s=>(
          <polyline key={s.id} points={s.pts}
            fill="none" stroke={s.color} strokeWidth={1.8} strokeLinejoin="round" opacity={0.9}/>
        ))}
        {/* X-axis */}
        <line x1={PAD.l} y1={PAD.t+IH} x2={PAD.l+IW} y2={PAD.t+IH}
          stroke="#e2e8f0" strokeWidth={1}/>
        {xLabels.map((lb,i)=>(
          <text key={i}
            x={PAD.l + (i/6)*IW} y={H-6}
            textAnchor="middle" fontSize={7} fill="#94a3b8">{lb}</text>
        ))}
        {/* Y-axis */}
        <line x1={PAD.l} y1={PAD.t} x2={PAD.l} y2={PAD.t+IH}
          stroke="#e2e8f0" strokeWidth={1}/>
      </svg>
    </div>
  )
}

function GiamSatLoCaoView() {
  const [selSection, setSelSection] = useState("lo-tren") // sidebar tabs
  const [selStove,   setSelStove]   = useState(null)
  const [hoveredId,  setHoveredId]  = useState(null)
  const [running,    setRunning]    = useState(true)

  const alarmsN = GS_TEMPS_LEFT.filter(t=>t.alarm).length

  // ── Shared helpers (same as every other view) ──
  const HPipe = ({color="#22c55e",active=true,flow=null,width=28,unit=""}) => (
    <div style={{display:"flex",flexDirection:"column",alignItems:"center",gap:1,flexShrink:0}}>
      <div style={{width,height:3,
        background:active?color:"#e2e8f0",borderRadius:2,opacity:active?1:0.5,
        boxShadow:active?`0 0 4px ${color}66`:"none",transition:"all .2s"}}/>
      {flow!=null&&<span style={{fontSize:7,color:active?color:"#94a3b8",fontWeight:600,whiteSpace:"nowrap"}}>
        {flow>0?`+${flow}`:flow} {unit}
      </span>}
    </div>
  )
  const Arrow = ({color="#22c55e",active=true,dir="right"}) => (
    <span style={{fontSize:10,color:active?color:"#e2e8f0",flexShrink:0,lineHeight:1,
      filter:active?`drop-shadow(0 0 2px ${color}88)`:"none"}}>
      {dir==="right"?"▶":"◀"}
    </span>
  )
  const ColHeader = ({title,count,extra=null}) => (
    <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",marginBottom:12}}>
      <span style={{fontSize:11,fontWeight:700,color:"#64748b",letterSpacing:1,textTransform:"uppercase"}}>
        {title} <span style={{fontWeight:400,fontSize:10,color:"#94a3b8"}}>({count})</span>
      </span>
      {extra||<button style={{width:22,height:22,borderRadius:"50%",background:"#22c55e",border:"none",
        cursor:"pointer",fontSize:14,color:"white",display:"flex",alignItems:"center",justifyContent:"center",
        boxShadow:"0 1px 4px rgba(34,197,94,.4)",flexShrink:0}}>+</button>}
    </div>
  )

  // ── Sidebar section tabs ──
  const SECTIONS = [
    {id:"lo-tren",  label:"Lò thân trên"},
    {id:"lo-giua",  label:"Lò thân giữa"},
    {id:"lo-duoi",  label:"Lò thân dưới"},
    {id:"nuoc",     label:"Nước"},
  ]

  // ── Section param cards — filtered by section ──
  const SECTION_PARAMS = {
    "lo-tren": GS_TEMPS_LEFT.slice(0,4),
    "lo-giua": GS_TEMPS_LEFT.slice(4,7),
    "lo-duoi": GS_TEMPS_LEFT.slice(7,10),
    "nuoc": [
      {key:"Lưu lượng cấp nước",val:0,  alarm:false},
      {key:"Lưu lượng hồi nước",val:0,  alarm:false},
      {key:"Nhiệt độ nước cấp",  val:0,  alarm:false},
    ],
  }

  return (
    <div style={{flex:1,display:"flex",overflow:"hidden"}}>

      {/* ── Main scrollable canvas ── */}
      <div style={{flex:1,overflow:"auto",padding:"14px 16px"}}>

        {/* KPI strip */}
        <div style={{display:"flex",gap:8,marginBottom:14,flexWrap:"wrap"}}>
          {[
            {label:"Áp suất đỉnh lò",   value:"37 kPa",    icon:"📊", color:"#2563eb"},
            {label:"Gió nóng",           value:"143.1 kPa", icon:"💨", color:"#ef4444"},
            {label:"Lưu lượng gió lạnh", value:"453 m³/h",  icon:"❄", color:"#0ea5e9"},
            {label:"Cảnh báo nhiệt độ",  value:`${alarmsN}`,icon:"⚠",  color:alarmsN>0?"#ef4444":"#22c55e"},
            {label:"Oxy giàu",           value:"1 350 m³/h",icon:"🧪", color:"#a855f7"},
          ].map(k=>(
            <div key={k.label} style={{
              background:"white",border:"1px solid #e2e8f0",borderRadius:8,
              padding:"8px 12px",display:"flex",alignItems:"center",gap:8,
              flex:1,minWidth:100,boxShadow:"0 1px 3px rgba(0,0,0,0.04)"
            }}>
              <span style={{fontSize:18}}>{k.icon}</span>
              <div>
                <div style={{fontSize:15,fontWeight:800,color:k.color,lineHeight:1}}>{k.value}</div>
                <div style={{fontSize:9,color:"#94a3b8",marginTop:1}}>{k.label}</div>
              </div>
            </div>
          ))}
        </div>

        {/* ── 3-column layout ── */}
        <div style={{display:"flex",gap:0,minWidth:640}}>

          {/* ── COL 1: Furnace diagram + temp readings ── */}
          <div style={{width:230,borderRight:"1px solid #e2e8f0",paddingRight:12,flexShrink:0}}>
            <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",marginBottom:12}}>
              <span style={{fontSize:11,fontWeight:700,color:"#64748b",
                letterSpacing:1,textTransform:"uppercase"}}>
                Lò cao 179m³
              </span>
              <div style={{display:"flex",gap:4}}>
                <button onClick={()=>setRunning(true)} style={{
                  padding:"3px 8px",border:"none",borderRadius:5,cursor:"pointer",
                  fontSize:9,fontWeight:600,
                  background:running?"#22c55e":"#f1f5f9",
                  color:running?"white":"#64748b"
                }}>▶</button>
                <button onClick={()=>setRunning(false)} style={{
                  padding:"3px 8px",border:"none",borderRadius:5,cursor:"pointer",
                  fontSize:9,fontWeight:600,
                  background:!running?"#ef4444":"#f1f5f9",
                  color:!running?"white":"#64748b"
                }}>■</button>
              </div>
            </div>

            {/* Furnace + temp grid side-by-side */}
            <div style={{display:"flex",gap:6,background:"white",border:"1px solid #e2e8f0",
              borderRadius:8,padding:"10px",boxShadow:"0 1px 3px rgba(0,0,0,0.04)"}}>
              {/* Left temp column */}
              <div style={{width:70,flexShrink:0}}>
                {GS_TEMPS_LEFT.slice(0,5).map(t=>(
                  <div key={t.key} style={{
                    padding:"3px 0",borderBottom:"1px solid #f8fafc",
                    display:"flex",justifyContent:"space-between",alignItems:"center"
                  }}>
                    <span style={{fontSize:7,color:"#94a3b8",lineHeight:1.2,
                      maxWidth:40,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>
                      {t.key.replace("Nhiệt độ ","").split(" ")[0]}
                    </span>
                    <span style={{
                      fontSize:9,fontWeight:800,fontFamily:"monospace",
                      color:t.alarm?"#ef4444":"#374151",
                      background:t.alarm?"#fee2e2":"#f1f5f9",
                      padding:"1px 4px",borderRadius:3,flexShrink:0
                    }}>{t.val}</span>
                  </div>
                ))}
              </div>
              {/* Furnace cross-section SVG */}
              <div style={{flex:1,display:"flex",justifyContent:"center"}}>
                <FurnaceCrossSection width={100} height={190} running={running}/>
              </div>
              {/* Right temp column */}
              <div style={{width:70,flexShrink:0}}>
                {GS_TEMPS_LEFT.slice(5).map(t=>(
                  <div key={t.key} style={{
                    padding:"3px 0",borderBottom:"1px solid #f8fafc",
                    display:"flex",justifyContent:"space-between",alignItems:"center"
                  }}>
                    <span style={{fontSize:7,color:"#94a3b8",lineHeight:1.2,
                      maxWidth:40,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>
                      {t.key.replace("Nhiệt độ ","").split(" ")[0]}
                    </span>
                    <span style={{
                      fontSize:9,fontWeight:800,fontFamily:"monospace",
                      color:t.alarm?"#ef4444":"#374151",
                      background:t.alarm?"#fee2e2":"#f1f5f9",
                      padding:"1px 4px",borderRadius:3,flexShrink:0
                    }}>{t.val}</span>
                  </div>
                ))}
              </div>
            </div>

            {/* Áp suất đỉnh card */}
            <div style={{background:"white",border:"1px solid #e2e8f0",borderRadius:8,
              padding:"8px 12px",marginTop:8,boxShadow:"0 1px 3px rgba(0,0,0,0.04)"}}>
              <div style={{fontSize:9,fontWeight:700,color:"#64748b",letterSpacing:1,
                textTransform:"uppercase",marginBottom:6}}>Áp suất đỉnh lò</div>
              <div style={{display:"flex",gap:8,alignItems:"center"}}>
                <div style={{flex:1,textAlign:"center"}}>
                  <div style={{fontSize:22,fontWeight:900,color:"#2563eb",fontFamily:"monospace"}}>37</div>
                  <div style={{fontSize:9,color:"#94a3b8"}}>kPa (Bắc)</div>
                </div>
                <div style={{width:1,height:36,background:"#e2e8f0"}}/>
                <div style={{flex:1,textAlign:"center"}}>
                  <div style={{fontSize:22,fontWeight:900,color:"#2563eb",fontFamily:"monospace"}}>35</div>
                  <div style={{fontSize:9,color:"#94a3b8"}}>kPa (Nam)</div>
                </div>
              </div>
            </div>
          </div>

          {/* ── COL 2: Hot stoves + system params ── */}
          <div style={{flex:1,borderRight:"1px solid #e2e8f0",padding:"0 12px",minWidth:180}}>
            <ColHeader title="Lò gió nóng" count={GS_HOT_STOVES.length}/>

            {/* Hot stove row — 3 stove cards inline */}
            <div style={{display:"flex",gap:6,marginBottom:10}}>
              {GS_HOT_STOVES.map(s=>{
                const isSel = selStove?.id===s.id
                return (
                  <div key={s.id}
                    onClick={()=>setSelStove(p=>p?.id===s.id?null:s)}
                    onMouseEnter={()=>setHoveredId(s.id)}
                    onMouseLeave={()=>setHoveredId(null)}
                    style={{
                      flex:1,background:"white",
                      border:`2px solid ${isSel?"#2563eb":s.burning?"#fca5a5":"#e2e8f0"}`,
                      borderRadius:8,padding:"8px",cursor:"pointer",textAlign:"center",
                      boxShadow:isSel?"0 0 0 3px rgba(37,99,235,.15)":
                        hoveredId===s.id?"0 2px 8px rgba(0,0,0,0.08)":"0 1px 3px rgba(0,0,0,0.04)",
                      transition:"all .15s"
                    }}>
                    {/* Icon */}
                    <div style={{fontSize:22,lineHeight:1.2,marginBottom:4}}>
                      {s.burning?"🔥":"○"}
                    </div>
                    {/* ID + state */}
                    <div style={{fontSize:11,fontWeight:800,color:isSel?"#2563eb":"#374151"}}>{s.id}</div>
                    <div style={{
                      fontSize:8,background:s.burning?"#fee2e2":"#f1f5f9",
                      color:s.burning?"#dc2626":"#64748b",
                      padding:"1px 6px",borderRadius:8,fontWeight:600,
                      display:"inline-block",marginTop:4
                    }}>{s.burning?"Đốt":"Dự trữ"}</div>
                    {/* Temperatures */}
                    <div style={{marginTop:6,display:"flex",flexDirection:"column",gap:2}}>
                      <div style={{display:"flex",justifyContent:"space-between",
                        padding:"2px 0",borderBottom:"1px solid #f8fafc"}}>
                        <span style={{fontSize:7,color:"#94a3b8"}}>Đỉnh</span>
                        <span style={{fontSize:10,fontWeight:800,fontFamily:"monospace",
                          color:s.burning?"#ef4444":"#94a3b8"}}>{s.tempTop}</span>
                      </div>
                      <div style={{display:"flex",justifyContent:"space-between",padding:"2px 0"}}>
                        <span style={{fontSize:7,color:"#94a3b8"}}>Đáy</span>
                        <span style={{fontSize:10,fontWeight:800,fontFamily:"monospace",
                          color:s.color}}>{s.tempBot}</span>
                      </div>
                    </div>
                    {/* Flow row */}
                    <div style={{marginTop:6,display:"flex",alignItems:"center",
                      justifyContent:"center",gap:3}}>
                      <HPipe color={s.color} active={s.active} width={20}/>
                      <Arrow color={s.color} active={s.active} dir={s.burning?"right":"left"}/>
                    </div>
                  </div>
                )
              })}
            </div>

            {/* Hot stove connecting pipes visual */}
            <div style={{
              background:"white",border:"1px solid #e2e8f0",borderRadius:8,
              padding:"8px 12px",marginBottom:10,
              boxShadow:"0 1px 3px rgba(0,0,0,0.04)"
            }}>
              <div style={{fontSize:9,fontWeight:700,color:"#64748b",letterSpacing:1,
                textTransform:"uppercase",marginBottom:6}}>Lưu lượng tổng</div>
              <div style={{display:"flex",alignItems:"center",gap:4}}>
                <div style={{width:14,height:3,background:"#2563eb",borderRadius:2}}/>
                <svg viewBox="0 0 28 18" style={{width:28,height:18,flexShrink:0}}>
                  <rect x={1} y={2} width={12} height={14} rx={2} fill="white" stroke="#2563eb" strokeWidth={1.5}/>
                  <circle cx={7} cy={9} r={3} fill="#2563eb" opacity={0.3}/>
                  <circle cx={7} cy={9} r={1.5} fill="#2563eb"/>
                  <line x1={13} y1={9} x2={18} y2={9} stroke="#2563eb" strokeWidth={1.5}/>
                  <rect x={18} y={2} width={9} height={14} rx={2} fill="white" stroke="#2563eb" strokeWidth={1.5}/>
                </svg>
                <Arrow color="#ef4444" active={true} dir="right"/>
                <div style={{flex:1,textAlign:"right"}}>
                  <span style={{fontSize:15,fontWeight:900,color:"#ef4444",fontFamily:"monospace"}}>453</span>
                  <span style={{fontSize:9,color:"#94a3b8",marginLeft:3}}>m³/h</span>
                </div>
              </div>
            </div>

            {/* System params — same inline card as SinteringLineView */}
            <div style={{background:"white",border:"1px solid #e2e8f0",borderRadius:8,
              padding:"10px 12px",boxShadow:"0 1px 3px rgba(0,0,0,0.04)"}}>
              <div style={{fontSize:10,fontWeight:700,color:"#374151",marginBottom:8}}>
                Thông Số Hệ Thống
              </div>
              {GS_PARAMS_TOP.map(p=>(
                <div key={p.key} style={{
                  display:"flex",alignItems:"center",justifyContent:"space-between",
                  padding:"4px 0",borderBottom:"1px solid #f8fafc"
                }}>
                  <span style={{fontSize:9,color:"#64748b",flex:1}}>{p.key}</span>
                  <div style={{display:"flex",alignItems:"baseline",gap:2}}>
                    <span style={{fontSize:12,fontWeight:800,fontFamily:"monospace",
                      color:p.alarm?"#ef4444":"#0f172a"}}>{p.val}</span>
                    {p.unit&&<span style={{fontSize:8,color:"#94a3b8"}}>{p.unit}</span>}
                    {p.sub&&<span style={{fontSize:8,color:"#94a3b8",marginLeft:4}}>/{p.sub}</span>}
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* ── COL 3: Trend chart + pressure valve ── */}
          <div style={{flex:1.2,paddingLeft:12,minWidth:180}}>

            {/* Pressure valve group card */}
            <div style={{background:"white",border:"1px solid #e2e8f0",borderRadius:8,
              padding:"10px 12px",marginBottom:10,
              boxShadow:"0 1px 3px rgba(0,0,0,0.04)"}}>
              <div style={{fontSize:10,fontWeight:700,color:"#374151",marginBottom:8,
                display:"flex",alignItems:"center",justifyContent:"space-between"}}>
                Điều Áp Van Nhóm
                <span style={{fontSize:12,fontWeight:900,color:"#2563eb",fontFamily:"monospace"}}>
                  0.0 <span style={{fontSize:9,fontWeight:400}}>kPa</span>
                </span>
              </div>
              <div style={{display:"flex",gap:6}}>
                {GS_PRESSURE_VALVES.map(v=>(
                  <div key={v.id} style={{
                    flex:1,background:"#f8fafc",border:"1px solid #e2e8f0",
                    borderRadius:6,padding:"6px",textAlign:"center"
                  }}>
                    <div style={{fontSize:10,fontWeight:700,color:"#374151"}}>{v.label}</div>
                    <div style={{
                      fontSize:11,fontWeight:800,fontFamily:"monospace",
                      color:v.open?"#22c55e":"#94a3b8",marginTop:2
                    }}>{v.val} <span style={{fontSize:8,color:"#94a3b8"}}>{v.unit}</span></div>
                    <div style={{
                      fontSize:9,background:v.open?"#dcfce7":"#f1f5f9",
                      color:v.open?"#16a34a":"#64748b",
                      padding:"1px 6px",borderRadius:8,fontWeight:600,
                      display:"inline-block",marginTop:4
                    }}>{v.open?"Mở":"Đóng"}</div>
                  </div>
                ))}
              </div>
            </div>

            {/* Multi-line trend chart */}
            <div style={{background:"white",border:"1px solid #e2e8f0",borderRadius:8,
              padding:"10px 12px",boxShadow:"0 1px 3px rgba(0,0,0,0.04)"}}>
              <div style={{
                display:"flex",alignItems:"center",justifyContent:"space-between",marginBottom:8
              }}>
                <div style={{fontSize:10,fontWeight:700,color:"#374151"}}>
                  WinCC Online Trend
                </div>
                <div style={{fontSize:8,color:"#94a3b8",fontFamily:"monospace"}}>
                  2025/06/23 16:56
                </div>
              </div>
              {/* Legend */}
              <div style={{display:"flex",gap:8,flexWrap:"wrap",marginBottom:6}}>
                {GS_TREND_SERIES.map(s=>(
                  <div key={s.id} style={{display:"flex",alignItems:"center",gap:3}}>
                    <div style={{width:16,height:2.5,background:s.color,borderRadius:2}}/>
                    <span style={{fontSize:8,color:"#64748b"}}>{s.label}</span>
                  </div>
                ))}
              </div>
              <TrendChart series={GS_TREND_SERIES} height={160}/>
              {/* Current values row */}
              <div style={{
                display:"flex",gap:4,flexWrap:"wrap",
                marginTop:8,paddingTop:8,borderTop:"1px solid #f1f5f9"
              }}>
                {GS_TREND_SERIES.map(s=>{
                  const last = s.data[s.data.length-1]
                  return (
                    <div key={s.id} style={{
                      flex:1,minWidth:70,textAlign:"center",
                      background:"#f8fafc",borderRadius:5,padding:"4px 3px"
                    }}>
                      <div style={{
                        fontSize:12,fontWeight:800,color:s.color,
                        fontFamily:"monospace",lineHeight:1
                      }}>{last.toFixed(1)}</div>
                      <div style={{fontSize:7,color:"#94a3b8",marginTop:1}}>{s.label}</div>
                    </div>
                  )
                })}
              </div>
            </div>

          </div>
        </div>
      </div>

      {/* ── Right detail panel — 268px, same as all views ── */}
      <div style={{
        width:268,background:"white",borderLeft:"1px solid #e2e8f0",
        flexShrink:0,overflowY:"auto",display:"flex",flexDirection:"column"
      }}>
        {/* Section tabs (工长班报 style) */}
        <div style={{borderBottom:"1px solid #e2e8f0",flexShrink:0}}>
          {SECTIONS.map((sec,i)=>(
            <button key={sec.id} onClick={()=>setSelSection(sec.id)} style={{
              display:"block",width:"100%",padding:"10px 14px",
              border:"none",borderLeft:`3px solid ${selSection===sec.id?"#1e3a5f":"transparent"}`,
              cursor:"pointer",textAlign:"left",
              background:selSection===sec.id?"#f0f9ff":"white",
              color:selSection===sec.id?"#1e3a5f":"#64748b",
              fontSize:11,fontWeight:selSection===sec.id?700:400,
              borderBottom:i<SECTIONS.length-1?"1px solid #f1f5f9":"none"
            }}>{sec.label}</button>
          ))}
        </div>

        {/* Section detail */}
        <div style={{flex:1,overflowY:"auto"}}>
          <div style={{padding:"8px 14px 2px",fontSize:9,fontWeight:700,
            color:"#94a3b8",letterSpacing:1,background:"#f8fafc",
            borderBottom:"1px solid #e2e8f0"}}>
            {SECTIONS.find(s=>s.id===selSection)?.label?.toUpperCase()}
          </div>

          {/* Stove detail if selected */}
          {selStove ? (
            <div>
              <div style={{padding:"10px 14px",background:"#f8fafc",borderBottom:"1px solid #e2e8f0",
                display:"flex",alignItems:"center",justifyContent:"space-between"}}>
                <div>
                  <span style={{fontSize:9,color:"#94a3b8",fontFamily:"monospace"}}>{selStove.id} · </span>
                  <span style={{fontSize:12,fontWeight:700,color:"#0f172a"}}>Lò gió nóng</span>
                </div>
                <span style={{
                  fontSize:9,background:selStove.burning?"#fee2e2":"#f1f5f9",
                  color:selStove.burning?"#dc2626":"#64748b",
                  padding:"2px 7px",borderRadius:8,fontWeight:600
                }}>{selStove.burning?"Đốt":"Dự trữ"}</span>
              </div>
              <div style={{display:"flex",borderBottom:"1px solid #f1f5f9"}}>
                {["Thông tin","Cảnh báo"].map((t,i)=>(
                  <button key={t} style={{padding:"8px 12px",border:"none",cursor:"pointer",
                    fontSize:11,fontWeight:i===0?700:400,
                    color:i===0?"#2563eb":"#94a3b8",
                    borderBottom:i===0?"2px solid #2563eb":"2px solid transparent",
                    background:"none"}}>{t}</button>
                ))}
              </div>
              {/* Gauge + value */}
              <div style={{padding:"14px",display:"flex",gap:12,alignItems:"center",
                background:"white",borderBottom:"1px solid #f1f5f9"}}>
                <StoveGauge temp={selStove.tempTop} burning={selStove.burning} width={44} height={80}/>
                <div>
                  <div style={{fontSize:22,fontWeight:800,
                    color:selStove.burning?"#ef4444":"#94a3b8",lineHeight:1,fontFamily:"monospace"}}>
                    {selStove.tempTop}
                    <span style={{fontSize:12,fontWeight:400,color:"#94a3b8",marginLeft:3}}>°C</span>
                  </div>
                  <div style={{fontSize:10,color:"#64748b",marginTop:3}}>Nhiệt độ đỉnh lò</div>
                  <div style={{marginTop:6,display:"inline-flex",alignItems:"center",gap:4,
                    background:selStove.burning?"#fee2e2":"#f1f5f9",
                    color:selStove.burning?"#dc2626":"#64748b",
                    padding:"2px 8px",borderRadius:10,fontSize:9,fontWeight:600}}>
                    {selStove.burning?"🔥 Đốt":"○ Dự trữ"}
                  </div>
                </div>
              </div>
              {[
                ["Nhiệt độ đỉnh", `${selStove.tempTop} °C`],
                ["Nhiệt độ đáy",  `${selStove.tempBot} °C`],
                ["Trạng thái",    selStove.burning?"Đốt":"Dự trữ"],
              ].map(([k,v])=>(
                <div key={k} style={{display:"flex",justifyContent:"space-between",
                  padding:"7px 14px",borderBottom:"1px solid #f8fafc"}}>
                  <span style={{fontSize:11,color:"#94a3b8"}}>{k}</span>
                  <span style={{fontSize:11,fontWeight:600,color:"#0f172a"}}>{v}</span>
                </div>
              ))}
              {/* Sparkline */}
              <div style={{padding:"8px 14px 2px",fontSize:9,fontWeight:700,
                color:"#94a3b8",letterSpacing:1,background:"#f8fafc",marginTop:4}}>6H QUA</div>
              <div style={{padding:"6px 14px 14px",background:"#f8fafc"}}>
                <Sparkline
                  data={genTrend(selStove.tempTop, 30)}
                  color={selStove.burning?"#ef4444":"#f59e0b"}
                  width={220} height={44}/>
                <div style={{display:"flex",justifyContent:"space-between",marginTop:3}}>
                  <span style={{fontSize:7,color:"#94a3b8"}}>-6h</span>
                  <span style={{fontSize:7,color:"#94a3b8"}}>hiện tại</span>
                </div>
              </div>
            </div>
          ) : (
            /* Section param list */
            <div>
              {(SECTION_PARAMS[selSection]||[]).map((t,i)=>(
                <div key={i} style={{
                  display:"flex",justifyContent:"space-between",alignItems:"center",
                  padding:"9px 14px",borderBottom:"1px solid #f8fafc"
                }}>
                  <span style={{fontSize:11,color:"#64748b",flex:1}}>{t.key}</span>
                  <div style={{display:"flex",alignItems:"center",gap:6}}>
                    <Sparkline
                      data={genTrend(t.val||50, 8)}
                      color={t.alarm?"#ef4444":"#2563eb"}
                      width={48} height={20}/>
                    <span style={{
                      fontSize:13,fontWeight:800,fontFamily:"monospace",
                      color:t.alarm?"#ef4444":"#0f172a",
                      background:t.alarm?"#fee2e2":"transparent",
                      padding:t.alarm?"1px 4px":"0",borderRadius:3,
                      minWidth:36,textAlign:"right"
                    }}>{t.val}</span>
                    {t.alarm&&<span style={{
                      width:14,height:14,borderRadius:"50%",background:"#ef4444",
                      display:"inline-flex",alignItems:"center",justifyContent:"center",
                      fontSize:7,color:"white",fontWeight:900,flexShrink:0
                    }}>!</span>}
                  </div>
                </div>
              ))}
              <div style={{padding:"20px",textAlign:"center",color:"#94a3b8",fontSize:11}}>
                <span style={{fontSize:24}}>🏭</span><br/>
                <span style={{marginTop:4,display:"block"}}>Nhấp lò gió nóng để xem chi tiết</span>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  )
}


// ─── Thu Hồi NL Nhiệt — Hệ Thống Lọc Bụi Túi ────────────

// ── Bag filter units: 12 bags, 2 rows (row A: 7-12, row B: 1-6) ──
const BAG_UNITS = Array.from({length:12}, (_,i) => {
  const id = i+1
  return {
    id, label:`${id}#`,
    row: id<=6 ? 'B' : 'A',
    active: id !== 4,
    pulse: [2,5,9,11].includes(id),
    alarm: [4].includes(id),
    fillPct: id===4 ? 0 : Math.floor(40 + Math.random()*45),
    valve: id===4 ? 'close' : 'open',
  }
})

// ── Cyclone separators ──
const CYCLONES = [
  { id:"CY-01", label:"Xyclon 1", active:true,  inFlow:350, color:"#64748b" },
  { id:"CY-02", label:"Xyclon 2", active:true,  inFlow:280, color:"#64748b" },
]

// ── System params ──
const FILTER_SYSTEM = {
  pressureInlet:  { val:"+68.72", unit:"kPa", alarm:false },
  pressureOutlet: { val:"-75.00", unit:"kPa", alarm:false },
  pressureDiff:   { val:"-3.72",  unit:"kPa", alarm:false },
  tempInlet:      { val:"+141",   unit:"°C",  alarm:false },
  cleanGasPres:   { val:"-76.00", unit:"kPa", alarm:false },
  n2Pressure:     { val:"+0.28",  unit:"MPa", alarm:false },
  gasFlow:        { val:"+0",     unit:"m³/h",alarm:true  },
}

const PULSE_CONTROLS = [
  { id:"PC-01", label:"Thời gian điều khiển", active:false },
  { id:"PC-02", label:"Sai áp điều khiển",    active:false },
  { id:"PC-03", label:"Chủ động điều khiển",  active:true  },
  { id:"PC-04", label:"Đơn vòng tuần hoàn",   active:false },
]

const RETURN_VALVE = { pct: 0, setpoint: 75, active: true }

// ── Butterfly valve state for each bag ──
const [initValves] = [BAG_UNITS.map(b=>b.valve)]

// ── Cyclone SVG ──
function CycloneSVG({ active=true, w=52, h=88 }) {
  const c = active ? "#64748b" : "#e2e8f0"
  const fc = active ? "#f1f5f9" : "#f8fafc"
  const cx = w/2
  return (
    <svg viewBox={`0 0 ${w} ${h}`} style={{width:w,height:h,display:"block"}}>
      {/* Inlet pipe top-right */}
      <rect x={cx-2} y={0} width={4} height={12} rx={1} fill={active?"#94a3b8":"#e2e8f0"}/>
      {/* Outer cylinder */}
      <rect x={6} y={8} width={w-12} height={40} rx={4}
        fill={fc} stroke={c} strokeWidth={1.5}/>
      {/* Inner swirl indicator */}
      <ellipse cx={cx} cy={28} rx={8} ry={6}
        fill={active?"#dbeafe":"#f1f5f9"} stroke={active?"#2563eb":"#e2e8f0"} strokeWidth={1}/>
      <path d={`M ${cx-4},28 Q ${cx},22 ${cx+4},28 Q ${cx},34 ${cx-4},28`}
        fill={active?"#2563eb":"#e2e8f0"} opacity={0.5}/>
      {/* Cone */}
      <polygon points={`6,48 ${w-6},48 ${cx+4},78 ${cx-4},78`}
        fill={fc} stroke={c} strokeWidth={1.5}/>
      {/* Outlet nozzle */}
      <rect x={cx-3} y={76} width={6} height={12} rx={1} fill={c}/>
      {/* Status dot */}
      <circle cx={w-10} cy={14} r={4}
        fill={active?"#22c55e":"#e2e8f0"} stroke="white" strokeWidth={1}/>
    </svg>
  )
}

// ── Bag filter SVG (single unit) ──
function BagSVG({ active=true, pulse=false, fillPct=60, alarm=false, w=36, h=64 }) {
  const c  = alarm ? "#ef4444" : active ? "#64748b" : "#e2e8f0"
  const fc = alarm ? "#fee2e2" : active ? "#f1f5f9" : "#f8fafc"
  const fh = Math.min(fillPct/100, 1) * 38
  const cx = w/2
  return (
    <svg viewBox={`0 0 ${w} ${h}`} style={{width:w,height:h,display:"block",flexShrink:0}}>
      {/* Inlet pipe top */}
      <rect x={cx-3} y={0} width={6} height={8} rx={1} fill={active?"#94a3b8":"#e2e8f0"}/>
      {/* Filter body */}
      <rect x={4} y={6} width={w-8} height={38} rx={3}
        fill={fc} stroke={c} strokeWidth={1.5}/>
      {/* Dust fill level */}
      <clipPath id={`bagclip-${w}-${h}-${fillPct}`}>
        <rect x={5} y={6} width={w-10} height={38}/>
      </clipPath>
      <rect x={5} y={6+(38-fh)} width={w-10} height={fh}
        fill={alarm?"#fca5a5":active?"#cbd5e1":"#e2e8f0"} opacity={0.7}
        clipPath={`url(#bagclip-${w}-${h}-${fillPct})`}/>
      {/* Horizontal filter ribs */}
      {[0.25,0.5,0.75].map((f,i)=>(
        <line key={i} x1={5} y1={6+38*f} x2={w-5} y2={6+38*f}
          stroke={c} strokeWidth={0.5} opacity={0.4}/>
      ))}
      {/* Pulse flash indicator */}
      {pulse && (
        <polygon points={`${cx-4},10 ${cx+4},10 ${cx},18`}
          fill="#f59e0b" opacity={0.9}/>
      )}
      {/* Hopper cone */}
      <polygon points={`4,44 ${w-4},44 ${cx+3},58 ${cx-3},58`}
        fill={fc} stroke={c} strokeWidth={1.5}/>
      {/* Outlet */}
      <rect x={cx-3} y={56} width={6} height={8} rx={1} fill={c}/>
      {/* Fan/motor circle below */}
      <circle cx={cx} cy={h-3} r={5} fill={active?"#dbeafe":"#f1f5f9"}
        stroke={active?"#2563eb":"#e2e8f0"} strokeWidth={1}/>
      <text x={cx} y={h} textAnchor="middle" fontSize={6} fontWeight="700"
        fill={active?"#2563eb":"#94a3b8"}>⊕</text>
      {/* Alarm badge */}
      {alarm && <circle cx={w-4} cy={8} r={4} fill="#ef4444" stroke="white" strokeWidth={1}/>}
    </svg>
  )
}

// ── Butterfly valve symbol ──
function ButterflyValve({ open=true, size=18 }) {
  const c = open ? "#22c55e" : "#ef4444"
  return (
    <svg viewBox={`0 0 ${size} ${size}`} style={{width:size,height:size,display:"block",flexShrink:0}}>
      <circle cx={size/2} cy={size/2} r={size/2-1} fill="white" stroke={c} strokeWidth={1.5}/>
      {open
        ? <ellipse cx={size/2} cy={size/2} rx={4} ry={7} fill={c} opacity={0.8}/>
        : <line x1={3} y1={size/2} x2={size-3} y2={size/2} stroke={c} strokeWidth={2.5}/>
      }
    </svg>
  )
}

function ThuHoiNLNhietView() {
  const [selBag,    setSelBag]    = useState(null)
  const [selCycl,   setSelCycl]   = useState(null)
  const [hovId,     setHovId]     = useState(null)
  const [valves,    setValves]    = useState(initValves)
  const [pulseMode, setPulseMode] = useState("chu-dong")
  const [activeTab, setActiveTab] = useState("loc-bui") // "loc-bui" | "bao-dong" | "lich-su"

  const openCount  = valves.filter(v=>v==="open").length
  const alarmCount = BAG_UNITS.filter(b=>b.alarm).length

  // ── same shared helpers ──
  const Arrow = ({color="#22c55e",active=true,dir="right"}) => (
    <span style={{fontSize:10,color:active?color:"#e2e8f0",flexShrink:0,lineHeight:1,
      filter:active?`drop-shadow(0 0 2px ${color}88)`:"none"}}>
      {dir==="right"?"▶":dir==="down"?"▼":"◀"}
    </span>
  )
  const HPipe = ({color="#22c55e",active=true,width=28,flow=null,unit="",vertical=false}) => (
    <div style={{display:"flex",flexDirection:"column",alignItems:"center",gap:1,flexShrink:0}}>
      <div style={{
        width:vertical?3:width, height:vertical?width:3,
        background:active?color:"#e2e8f0", borderRadius:2, opacity:active?1:0.5,
        boxShadow:active?`0 0 4px ${color}66`:"none", transition:"all .2s"
      }}/>
      {flow!=null&&<span style={{fontSize:7,color:active?color:"#94a3b8",fontWeight:600,whiteSpace:"nowrap"}}>
        {flow>0?`+${flow}`:flow} {unit}
      </span>}
    </div>
  )

  // ── Bag grid row ──
  const BagRow = ({bags}) => (
    <div style={{display:"flex",gap:4,justifyContent:"center"}}>
      {bags.map((bag,i) => {
        const isSel  = selBag?.id===bag.id
        const isHov  = hovId===`bag-${bag.id}`
        const vState = valves[bag.id-1]
        return (
          <div key={bag.id}
            onClick={()=>setSelBag(isSel?null:bag)}
            onMouseEnter={()=>setHovId(`bag-${bag.id}`)}
            onMouseLeave={()=>setHovId(null)}
            style={{
              display:"flex", flexDirection:"column", alignItems:"center", gap:2,
              background: isSel?"#eff6ff": bag.alarm?"#fef2f2":"white",
              border:`2px solid ${isSel?"#2563eb":bag.alarm?"#fca5a5":"#e2e8f0"}`,
              borderRadius:6, padding:"6px 4px", cursor:"pointer",
              boxShadow: isSel?"0 0 0 3px rgba(37,99,235,.15)":
                isHov?"0 2px 8px rgba(0,0,0,0.08)":"0 1px 2px rgba(0,0,0,0.03)",
              transition:"all .15s", minWidth:44, opacity:bag.active?1:0.55
            }}>
            <BagSVG active={bag.active} pulse={bag.pulse} fillPct={bag.fillPct}
              alarm={bag.alarm} w={32} h={58}/>
            <div style={{fontSize:9,fontWeight:700,
              color:isSel?"#2563eb":bag.alarm?"#ef4444":"#374151"}}>{bag.label}</div>
            <ButterflyValve open={vState==="open"} size={14}/>
          </div>
        )
      })}
    </div>
  )

  // ── Detail panel content ──
  const DetailPanel = () => {
    if (!selBag && !selCycl) return (
      <div style={{height:"100%",display:"flex",flexDirection:"column",
        alignItems:"center",justifyContent:"center",
        color:"#94a3b8",fontSize:12,padding:20,textAlign:"center",gap:8}}>
        <span style={{fontSize:32}}>🏭</span>
        <span style={{fontWeight:600,color:"#64748b"}}>Chọn thiết bị</span>
        <span style={{fontSize:11,color:"#cbd5e1",lineHeight:1.5}}>
          Nhấp vào túi lọc hoặc xyclon để xem chi tiết
        </span>
      </div>
    )
    const item  = selBag || selCycl
    const isBag = !!selBag
    const isAlarm = isBag ? item.alarm : false
    const trend = Array.from({length:18},(_,i)=>
      30 + Math.abs(Math.sin(i/3))*50 + (Math.random()-.5)*8
    )
    const fields = isBag ? [
      ["Túi lọc",    item.label],
      ["Trạng thái", item.active?"Đang chạy":"Dừng"],
      ["Mức bụi",    `${item.fillPct}%`],
      ["Van bướm",   valves[item.id-1]==="open"?"Mở":"Đóng"],
      ["Xung khí",   item.pulse?"Đang xung":"Không"],
      ["Cảnh báo",   item.alarm?"⚠ Có":"Không"],
    ] : [
      ["Xyclon",     item.label],
      ["Trạng thái", item.active?"Đang chạy":"Dừng"],
      ["Lưu lượng",  `${item.inFlow} m³/h`],
    ]
    return (
      <div>
        <div style={{padding:"10px 14px",background:"#f8fafc",borderBottom:"1px solid #e2e8f0",
          display:"flex",alignItems:"center",justifyContent:"space-between"}}>
          <div>
            <span style={{fontSize:9,color:"#94a3b8",fontFamily:"monospace"}}>{item.id||item.label} · </span>
            <span style={{fontSize:12,fontWeight:700,color:"#0f172a"}}>
              {isBag?`Túi lọc ${item.label}`:item.label}
            </span>
          </div>
          {isAlarm&&<span style={{width:18,height:18,borderRadius:"50%",background:"#ef4444",
            display:"inline-flex",alignItems:"center",justifyContent:"center",
            fontSize:9,color:"white",fontWeight:900}}>!</span>}
        </div>
        <div style={{display:"flex",borderBottom:"1px solid #f1f5f9"}}>
          {["Thông tin","Lịch sử"].map((t,i)=>(
            <button key={t} style={{padding:"8px 12px",border:"none",cursor:"pointer",fontSize:11,
              fontWeight:i===0?700:400,color:i===0?"#2563eb":"#94a3b8",
              borderBottom:i===0?"2px solid #2563eb":"2px solid transparent",
              background:"none"}}>{t}</button>
          ))}
        </div>
        {/* Bag visual preview */}
        {isBag && (
          <div style={{padding:"12px",background:"white",borderBottom:"1px solid #f1f5f9",
            display:"flex",justifyContent:"center",gap:12,alignItems:"center"}}>
            <BagSVG active={item.active} pulse={item.pulse} fillPct={item.fillPct}
              alarm={item.alarm} w={44} h={76}/>
            <div>
              <div style={{fontSize:20,fontWeight:900,
                color:item.alarm?"#ef4444":item.active?"#0f172a":"#94a3b8",
                lineHeight:1,fontFamily:"monospace"}}>
                {item.fillPct}<span style={{fontSize:11,fontWeight:400,color:"#94a3b8",marginLeft:2}}>%</span>
              </div>
              <div style={{fontSize:10,color:"#64748b",marginTop:3}}>Mức bụi</div>
              <div style={{marginTop:6,display:"inline-flex",alignItems:"center",gap:4,
                background:item.active?"#dcfce7":"#fee2e2",
                color:item.active?"#16a34a":"#dc2626",
                padding:"2px 8px",borderRadius:10,fontSize:9,fontWeight:600}}>
                {item.active?"Đang lọc":"Dừng"}
              </div>
            </div>
          </div>
        )}
        {/* Fields */}
        {fields.map(([k,v])=>(
          <div key={k} style={{display:"flex",justifyContent:"space-between",
            padding:"7px 14px",borderBottom:"1px solid #f8fafc"}}>
            <span style={{fontSize:11,color:"#94a3b8"}}>{k}</span>
            <span style={{fontSize:11,fontWeight:600,
              color:k==="Cảnh báo"&&v!=="Không"?"#ef4444":
                k==="Trạng thái"&&v==="Dừng"?"#dc2626":"#0f172a"}}>{v}</span>
          </div>
        ))}
        {/* Trend */}
        <div style={{padding:"8px 14px 2px",fontSize:9,fontWeight:700,
          color:"#94a3b8",letterSpacing:1,background:"#f8fafc",marginTop:4}}>GIỜ VỪA QUA</div>
        <div style={{padding:"6px 14px 14px",background:"#f8fafc"}}>
          <div style={{display:"flex",alignItems:"flex-end",gap:1,height:44}}>
            {trend.map((v,idx)=>(
              <div key={idx} style={{flex:1,height:`${v}%`,
                background:isAlarm?"#ef4444":"#2563eb",
                borderRadius:"1px 1px 0 0",opacity:0.8}}/>
            ))}
          </div>
          <div style={{display:"flex",justifyContent:"space-between",marginTop:2}}>
            <span style={{fontSize:7,color:"#94a3b8"}}>-1h</span>
            <span style={{fontSize:7,color:"#94a3b8"}}>hiện tại</span>
          </div>
        </div>
      </div>
    )
  }

  const rowA = BAG_UNITS.filter(b=>b.row==="A")   // bags 7-12
  const rowB = BAG_UNITS.filter(b=>b.row==="B")   // bags 1-6

  return (
    <div style={{flex:1,display:"flex",overflow:"hidden"}}>

      {/* ── Main scrollable canvas ── */}
      <div style={{flex:1,overflow:"auto",padding:"14px 16px"}}>

        {/* KPI strip */}
        <div style={{display:"flex",gap:8,marginBottom:14,flexWrap:"wrap"}}>
          {[
            {label:"Áp suất vào",     value:"+68.72 kPa", icon:"📥", color:"#2563eb"},
            {label:"Áp suất ra",      value:"-75.00 kPa", icon:"📤", color:"#0ea5e9"},
            {label:"Chênh lệch AP",   value:"-3.72 kPa",  icon:"📊", color:"#f59e0b"},
            {label:"Nhiệt độ vào",    value:"+141 °C",    icon:"🌡", color:"#ef4444"},
            {label:"Cảnh báo",        value:`${alarmCount}`, icon:"⚠", color:alarmCount>0?"#ef4444":"#22c55e"},
            {label:"Van mở / tổng",   value:`${openCount}/12`,icon:"🔧",color:"#22c55e"},
          ].map(k=>(
            <div key={k.label} style={{
              background:"white",border:"1px solid #e2e8f0",borderRadius:8,
              padding:"8px 12px",display:"flex",alignItems:"center",gap:8,
              flex:1,minWidth:90,boxShadow:"0 1px 3px rgba(0,0,0,0.04)"
            }}>
              <span style={{fontSize:18}}>{k.icon}</span>
              <div>
                <div style={{fontSize:14,fontWeight:800,color:k.color,lineHeight:1}}>{k.value}</div>
                <div style={{fontSize:9,color:"#94a3b8",marginTop:1}}>{k.label}</div>
              </div>
            </div>
          ))}
        </div>

        {/* 3-column layout */}
        <div style={{display:"flex",gap:0,minWidth:600}}>

          {/* ── COL 1: Cyclones + controls ── */}
          <div style={{width:200,borderRight:"1px solid #e2e8f0",paddingRight:12,flexShrink:0}}>

            {/* Cyclone separators */}
            <div style={{
              display:"flex",alignItems:"center",justifyContent:"space-between",marginBottom:12
            }}>
              <span style={{fontSize:11,fontWeight:700,color:"#64748b",
                letterSpacing:1,textTransform:"uppercase"}}>
                Xyclon <span style={{fontWeight:400,fontSize:10,color:"#94a3b8"}}>({CYCLONES.length})</span>
              </span>
            </div>
            <div style={{
              background:"white",border:"1px solid #e2e8f0",borderRadius:8,
              padding:"10px 8px",marginBottom:10,
              boxShadow:"0 1px 3px rgba(0,0,0,0.04)"
            }}>
              {/* Inlet pipe + pressure */}
              <div style={{
                display:"flex",alignItems:"center",gap:4,marginBottom:8,
                padding:"4px 6px",background:"#f0f9ff",borderRadius:6,
                border:"1px solid #bfdbfe"
              }}>
                <Arrow color="#2563eb" active={true} dir="right"/>
                <HPipe color="#2563eb" active={true} width={20}/>
                <span style={{fontSize:11,fontWeight:800,color:"#2563eb",
                  fontFamily:"monospace",flex:1,textAlign:"right"}}>
                  +68.72 <span style={{fontSize:8,fontWeight:400}}>kPa</span>
                </span>
              </div>
              {/* 2 cyclones side-by-side */}
              <div style={{display:"flex",gap:8,justifyContent:"center",marginBottom:8}}>
                {CYCLONES.map(cy=>{
                  const isSel = selCycl?.id===cy.id
                  return (
                    <div key={cy.id}
                      onClick={()=>{
                        setSelCycl(isSel?null:cy)
                        setSelBag(null)
                      }}
                      style={{
                        display:"flex",flexDirection:"column",alignItems:"center",gap:3,
                        background:isSel?"#eff6ff":"#f8fafc",
                        border:`2px solid ${isSel?"#2563eb":"#e2e8f0"}`,
                        borderRadius:6,padding:"6px 8px",cursor:"pointer",
                        boxShadow:isSel?"0 0 0 3px rgba(37,99,235,.15)":
                          "0 1px 2px rgba(0,0,0,0.04)",
                        transition:"all .15s"
                      }}>
                      <CycloneSVG active={cy.active} w={48} h={80}/>
                      <div style={{fontSize:9,fontWeight:700,
                        color:isSel?"#2563eb":"#374151"}}>{cy.label}</div>
                      <div style={{fontSize:8,color:"#64748b",fontFamily:"monospace"}}>
                        {cy.inFlow} m³/h
                      </div>
                    </div>
                  )
                })}
              </div>
              {/* Outlet + pressure */}
              <div style={{
                display:"flex",alignItems:"center",gap:4,
                padding:"4px 6px",background:"#f0fdf4",borderRadius:6,
                border:"1px solid #bbf7d0"
              }}>
                <HPipe color="#22c55e" active={true} width={20}/>
                <Arrow color="#22c55e" active={true} dir="right"/>
                <span style={{fontSize:11,fontWeight:800,color:"#22c55e",
                  fontFamily:"monospace",flex:1,textAlign:"right"}}>
                  -75.00 <span style={{fontSize:8,fontWeight:400}}>kPa</span>
                </span>
              </div>
            </div>

            {/* Pulse blowing control panel */}
            <div style={{background:"white",border:"1px solid #e2e8f0",borderRadius:8,
              padding:"10px 10px",marginBottom:10,
              boxShadow:"0 1px 3px rgba(0,0,0,0.04)"}}>
              <div style={{fontSize:10,fontWeight:700,color:"#374151",marginBottom:8}}>
                Điều Khiển Phun Xung
              </div>
              {PULSE_CONTROLS.map(pc=>(
                <div key={pc.id} style={{
                  display:"flex",alignItems:"center",justifyContent:"space-between",
                  padding:"4px 0",borderBottom:"1px solid #f8fafc"
                }}>
                  <span style={{fontSize:9,color:"#64748b"}}>{pc.label}</span>
                  <span style={{
                    fontSize:8,fontWeight:700,
                    background:pc.active?"#dcfce7":"#f1f5f9",
                    color:pc.active?"#16a34a":"#94a3b8",
                    padding:"1px 6px",borderRadius:8
                  }}>{pc.active?"ON":"OFF"}</span>
                </div>
              ))}
            </div>

            {/* Return valve control */}
            <div style={{background:"white",border:"1px solid #e2e8f0",borderRadius:8,
              padding:"10px 10px",
              boxShadow:"0 1px 3px rgba(0,0,0,0.04)"}}>
              <div style={{fontSize:10,fontWeight:700,color:"#374151",marginBottom:8}}>
                Hồi Nước Van Điều Khiển
              </div>
              {/* Progress bar fill */}
              <div style={{display:"flex",justifyContent:"space-between",
                fontSize:9,color:"#94a3b8",marginBottom:4}}>
                <span>Hiện tại</span>
                <span style={{fontFamily:"monospace",fontWeight:700,color:"#2563eb"}}>
                  {RETURN_VALVE.pct}%
                </span>
              </div>
              <div style={{height:6,background:"#f1f5f9",borderRadius:3,overflow:"hidden",marginBottom:6}}>
                <div style={{height:"100%",width:`${RETURN_VALVE.pct}%`,
                  background:"#2563eb",borderRadius:3}}/>
              </div>
              <div style={{display:"flex",gap:4}}>
                {["+1","-1","+5","-5"].map(s=>(
                  <button key={s} style={{
                    flex:1,padding:"3px 0",border:"1px solid #e2e8f0",
                    borderRadius:4,background:"white",fontSize:9,fontWeight:700,
                    color:s.startsWith("+")?("#16a34a"):("#dc2626"),
                    cursor:"pointer"
                  }}>{s}</button>
                ))}
              </div>
              {/* Clean gas params */}
              <div style={{marginTop:10}}>
                {[
                  {k:"Áp suất khí sạch",   v:FILTER_SYSTEM.cleanGasPres.val,  u:"kPa",  c:"#22c55e"},
                  {k:"Áp suất N₂ xung",    v:FILTER_SYSTEM.n2Pressure.val,    u:"MPa",  c:"#2563eb"},
                  {k:"Lưu lượng khí lò",   v:FILTER_SYSTEM.gasFlow.val,       u:"m³/h", c:"#ef4444",alarm:true},
                ].map(r=>(
                  <div key={r.k} style={{
                    display:"flex",justifyContent:"space-between",alignItems:"center",
                    padding:"5px 0",borderBottom:"1px solid #f8fafc"
                  }}>
                    <span style={{fontSize:9,color:"#64748b"}}>{r.k}</span>
                    <div style={{display:"flex",alignItems:"center",gap:4}}>
                      <span style={{fontSize:12,fontWeight:800,fontFamily:"monospace",
                        color:r.alarm?"#ef4444":r.c}}>{r.v}</span>
                      <span style={{fontSize:8,color:"#94a3b8"}}>{r.u}</span>
                      {r.alarm&&<span style={{width:12,height:12,borderRadius:"50%",
                        background:"#ef4444",display:"inline-flex",alignItems:"center",
                        justifyContent:"center",fontSize:6,color:"white",fontWeight:900}}>!</span>}
                    </div>
                  </div>
                ))}
              </div>
            </div>

          </div>

          {/* ── COL 2+3: Bag filter grid + bottom controls ── */}
          <div style={{flex:1,padding:"0 12px"}}>

            {/* Pressure diff header bar */}
            <div style={{
              background:"white",border:"1px solid #e2e8f0",borderRadius:8,
              padding:"8px 16px",marginBottom:10,
              boxShadow:"0 1px 3px rgba(0,0,0,0.04)",
              display:"flex",alignItems:"center",gap:16,justifyContent:"center"
            }}>
              <div style={{display:"flex",alignItems:"center",gap:6}}>
                <HPipe color="#2563eb" active={true} width={30}/>
                <Arrow color="#2563eb" active={true} dir="right"/>
              </div>
              <div style={{textAlign:"center"}}>
                <div style={{fontSize:16,fontWeight:900,color:"#f59e0b",fontFamily:"monospace"}}>
                  -3.72 <span style={{fontSize:10,fontWeight:400,color:"#94a3b8"}}>kPa</span>
                </div>
                <div style={{fontSize:9,color:"#94a3b8"}}>Chênh lệch áp</div>
              </div>
              <div style={{display:"flex",alignItems:"center",gap:6}}>
                <Arrow color="#22c55e" active={true} dir="right"/>
                <HPipe color="#22c55e" active={true} width={30}/>
              </div>
            </div>

            {/* Row A header (7-12) */}
            <div style={{fontSize:10,fontWeight:700,color:"#64748b",
              letterSpacing:1,textTransform:"uppercase",marginBottom:6}}>
              Dãy A (7# – 12#)
            </div>
            <div style={{background:"white",border:"1px solid #e2e8f0",borderRadius:8,
              padding:"10px 8px",marginBottom:10,
              boxShadow:"0 1px 3px rgba(0,0,0,0.04)"}}>
              {/* Top manifold pipe */}
              <div style={{height:4,background:"linear-gradient(90deg,#2563eb44,#0ea5e944)",
                borderRadius:2,marginBottom:8}}/>
              <BagRow bags={rowA}/>
              {/* Bottom manifold */}
              <div style={{height:4,background:"linear-gradient(90deg,#22c55e44,#22c55e22)",
                borderRadius:2,marginTop:8}}/>
            </div>

            {/* Row B header (1-6) */}
            <div style={{fontSize:10,fontWeight:700,color:"#64748b",
              letterSpacing:1,textTransform:"uppercase",marginBottom:6}}>
              Dãy B (1# – 6#)
            </div>
            <div style={{background:"white",border:"1px solid #e2e8f0",borderRadius:8,
              padding:"10px 8px",marginBottom:10,
              boxShadow:"0 1px 3px rgba(0,0,0,0.04)"}}>
              <div style={{height:4,background:"linear-gradient(90deg,#2563eb44,#0ea5e944)",
                borderRadius:2,marginBottom:8}}/>
              <BagRow bags={rowB}/>
              <div style={{height:4,background:"linear-gradient(90deg,#22c55e44,#22c55e22)",
                borderRadius:2,marginTop:8}}/>
            </div>

            {/* ── Bottom: valve control matrix + pulse selector ── */}
            <div style={{
              background:"white",border:"1px solid #e2e8f0",borderRadius:8,
              padding:"10px 12px",boxShadow:"0 1px 3px rgba(0,0,0,0.04)"
            }}>
              <div style={{fontSize:10,fontWeight:700,color:"#374151",marginBottom:8}}>
                Khí Động Bướm Van · Thủ Công Điều Khiển
              </div>
              {/* Valve matrix header */}
              <div style={{display:"flex",gap:2,marginBottom:4}}>
                <span style={{width:60,fontSize:9,color:"#94a3b8"}}>Van</span>
                {BAG_UNITS.map(b=>(
                  <span key={b.id} style={{
                    flex:1,textAlign:"center",fontSize:8,fontWeight:700,color:"#374151"
                  }}>{b.id}#</span>
                ))}
              </div>
              {/* Open/close buttons row */}
              {["Mở","Đóng"].map(action=>(
                <div key={action} style={{display:"flex",gap:2,marginBottom:3}}>
                  <span style={{width:60,fontSize:9,color:"#64748b",
                    display:"flex",alignItems:"center"}}>{action}</span>
                  {BAG_UNITS.map(b=>{
                    const isAction = action==="Mở"?valves[b.id-1]==="open":valves[b.id-1]==="close"
                    return (
                      <button key={b.id}
                        onClick={()=>{
                          const nv = [...valves]
                          nv[b.id-1] = action==="Mở"?"open":"close"
                          setValves(nv)
                        }}
                        style={{
                          flex:1,padding:"2px 0",border:"none",
                          borderRadius:3,cursor:"pointer",fontSize:8,fontWeight:700,
                          background:isAction
                            ?(action==="Mở"?"#22c55e":"#ef4444")
                            :"#f1f5f9",
                          color:isAction?"white":"#94a3b8",
                          transition:"all .15s"
                        }}>
                        {action==="Mở"?"开":"关"}
                      </button>
                    )
                  })}
                </div>
              ))}

              {/* Pulse selector */}
              <div style={{marginTop:10,paddingTop:8,borderTop:"1px solid #f1f5f9"}}>
                <div style={{fontSize:9,fontWeight:700,color:"#64748b",
                  letterSpacing:1,textTransform:"uppercase",marginBottom:6}}>
                  Xung Chọn Kho
                </div>
                <div style={{display:"flex",gap:3,flexWrap:"wrap"}}>
                  {["Tất cả",1,2,3,4,5,6,7,8,9,10,11,12,13].map(v=>(
                    <button key={v}
                      style={{
                        padding:"3px 6px",border:"1px solid #e2e8f0",
                        borderRadius:4,background:"white",
                        fontSize:9,fontWeight:600,cursor:"pointer",
                        color:"#374151"
                      }}>{v===0?"Hủy":v}</button>
                  ))}
                  <button style={{
                    padding:"3px 8px",border:"none",borderRadius:4,
                    background:"#ef4444",color:"white",
                    fontSize:9,fontWeight:700,cursor:"pointer"
                  }}>Dừng khẩn</button>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>

      {/* ── Right detail panel 268px ── */}
      <div style={{
        width:268,background:"white",borderLeft:"1px solid #e2e8f0",
        flexShrink:0,overflowY:"auto"
      }}>
        <DetailPanel/>
      </div>
    </div>
  )
}


function PXLGPanel() {
  const [pxlgSubTab,   setPxlgSubTab]   = useState("Phối Liệu Lò Cao")
  const [search,       setSearch]       = useState("")
  const [filterType,   setFilterType]   = useState("Tous")
  const [alarmOnly,    setAlarmOnly]    = useState(false)
  const [viewMode,     setViewMode]     = useState("table")
  const [selectedItem, setSelectedItem] = useState(null)

  const types = ["Tous", ...Array.from(new Set(PXLG_DATA.map(d=>d.type)))]

  const filtered = PXLG_DATA.filter(d => {
    if (alarmOnly && !d.alarm) return false
    if (filterType !== "Tous" && d.type !== filterType) return false
    if (search && !d.name.toLowerCase().includes(search.toLowerCase()) &&
                  !d.id.toLowerCase().includes(search.toLowerCase())) return false
    return true
  })

  return (
    <div style={{flex:1,display:"flex",flexDirection:"column",overflow:"hidden",background:"#f8fafc"}}>

      {/* Tab bar */}
      <div style={{
        background:"white",borderBottom:"1px solid #e2e8f0",
        padding:"0 16px",display:"flex",alignItems:"center",gap:4,flexShrink:0
      }}>
        {["Thiết bị","Phối Liệu Lò Cao","Công Nghệ Lò Cao","Giám Sát Lò Cao","Thu Hồi NL Nhiệt"].map(t=>(
          <button key={t} onClick={()=>setPxlgSubTab(t)} style={{
            padding:"10px 16px",border:"none",cursor:"pointer",fontSize:12,fontWeight:500,
            background:"transparent",
            color:pxlgSubTab===t?"#1e3a5f":"#64748b",
            borderBottom:pxlgSubTab===t?"2px solid #1e3a5f":"2px solid transparent",
            transition:"all .15s",whiteSpace:"nowrap"
          }}>{t}</button>
        ))}
      </div>

      {pxlgSubTab==="Phối Liệu Lò Cao" ? <LoCaoView/> : pxlgSubTab==="Công Nghệ Lò Cao" ? <CongNgheLoCaoView/> : pxlgSubTab==="Giám Sát Lò Cao" ? <GiamSatLoCaoView/> : pxlgSubTab==="Thu Hồi NL Nhiệt" ? <ThuHoiNLNhietView/> : (
      <>
      {/* Toolbar */}
      <div style={{
        background:"white",borderBottom:"1px solid #e2e8f0",
        padding:"10px 16px",display:"flex",alignItems:"center",gap:10,flexShrink:0,flexWrap:"wrap"
      }}>
        <div style={{
          display:"flex",alignItems:"center",gap:6,background:"#f8fafc",
          border:"1px solid #e2e8f0",borderRadius:6,padding:"5px 10px",minWidth:180
        }}>
          <span style={{color:"#94a3b8",fontSize:13}}>🔍</span>
          <input value={search} onChange={e=>setSearch(e.target.value)}
            placeholder="Tìm kiếm..."
            style={{border:"none",outline:"none",background:"transparent",fontSize:12,color:"#374151",width:140}}/>
        </div>
        <div style={{display:"flex",gap:4,flexWrap:"wrap"}}>
          {types.map(t=>(
            <button key={t} onClick={()=>setFilterType(t)} style={{
              padding:"4px 10px",border:"none",borderRadius:12,cursor:"pointer",fontSize:11,fontWeight:500,
              background:filterType===t?"#2563eb":"#f1f5f9",
              color:filterType===t?"white":"#64748b",transition:"all .15s"
            }}>{t}</button>
          ))}
        </div>
        <button onClick={()=>setAlarmOnly(p=>!p)} style={{
          padding:"4px 10px",border:`1px solid ${alarmOnly?"#ef4444":"#e2e8f0"}`,
          borderRadius:12,cursor:"pointer",fontSize:11,fontWeight:500,
          background:alarmOnly?"#fee2e2":"white",
          color:alarmOnly?"#ef4444":"#64748b",transition:"all .15s"
        }}>⚠ Chỉ cảnh báo</button>
        <div style={{flex:1}}/>
        <span style={{fontSize:11,color:"#94a3b8"}}>{filtered.length} thiết bị</span>
        <div style={{display:"flex",gap:2}}>
          {["table","grid"].map(m=>(
            <button key={m} onClick={()=>setViewMode(m)} style={{
              padding:"5px 8px",border:"none",borderRadius:5,cursor:"pointer",
              background:viewMode===m?"#2563eb":"#f1f5f9",
              color:viewMode===m?"white":"#64748b",fontSize:13,transition:"all .15s"
            }}>{m==="table"?"≡":"⊞"}</button>
          ))}
        </div>
      </div>

      {/* Content + detail */}
      <div style={{flex:1,display:"flex",overflow:"hidden"}}>

        <div style={{flex:1,overflow:"auto"}}>
          {viewMode==="table" ? (
            <table style={{width:"100%",borderCollapse:"collapse",fontSize:12}}>
              <thead>
                <tr style={{background:"#f8fafc",borderBottom:"2px solid #e2e8f0"}}>
                  {["ID","Tên thiết bị","Loại","SL","Ngày SD","Trạng thái","Cảnh báo"].map(h=>(
                    <th key={h} style={{padding:"8px 12px",textAlign:"left",fontWeight:600,
                      color:"#64748b",fontSize:11,whiteSpace:"nowrap"}}>{h}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {filtered.map(item=>{
                  const ss = PXLG_STATUS_STYLES[item.status]||PXLG_STATUS_STYLES.ok
                  const isSel = selectedItem?.id===item.id
                  return (
                    <tr key={item.id} onClick={()=>setSelectedItem(p=>p?.id===item.id?null:item)}
                      style={{
                        background:isSel?"#eff6ff":item.alarm?"#fff7f7":"white",
                        borderBottom:"1px solid #f1f5f9",cursor:"pointer",transition:"background .1s"
                      }}>
                      <td style={{padding:"8px 12px",fontFamily:"monospace",color:"#64748b",fontSize:11}}>{item.id}</td>
                      <td style={{padding:"8px 12px",fontWeight:600,color:"#0f172a",maxWidth:260}}>{item.name}</td>
                      <td style={{padding:"8px 12px",color:"#64748b",whiteSpace:"nowrap"}}>{item.type}</td>
                      <td style={{padding:"8px 12px",textAlign:"center",fontWeight:700,color:"#374151"}}>{item.qty}</td>
                      <td style={{padding:"8px 12px",color:"#64748b",whiteSpace:"nowrap",fontSize:11}}>{item.since}</td>
                      <td style={{padding:"8px 12px"}}>
                        <span style={{background:ss.bg,color:ss.color,padding:"2px 8px",
                          borderRadius:8,fontSize:10,fontWeight:600}}>{ss.label}</span>
                      </td>
                      <td style={{padding:"8px 12px",textAlign:"center"}}>
                        {item.alarm
                          ? <span style={{width:18,height:18,borderRadius:"50%",background:"#ef4444",
                              display:"inline-flex",alignItems:"center",justifyContent:"center",
                              fontSize:9,color:"white",fontWeight:900}}>!</span>
                          : <span style={{color:"#22c55e",fontSize:14}}>✓</span>}
                      </td>
                    </tr>
                  )
                })}
              </tbody>
            </table>
          ) : (
            <div style={{
              display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(180px,1fr))",
              gap:10,padding:14
            }}>
              {filtered.map(item=>{
                const ss = PXLG_STATUS_STYLES[item.status]||PXLG_STATUS_STYLES.ok
                const isSel = selectedItem?.id===item.id
                return (
                  <div key={item.id} onClick={()=>setSelectedItem(p=>p?.id===item.id?null:item)}
                    style={{
                      background:"white",borderRadius:8,padding:12,cursor:"pointer",
                      border:`2px solid ${isSel?"#2563eb":item.alarm?"#fca5a5":"#e2e8f0"}`,
                      boxShadow:isSel?"0 0 0 3px rgba(37,99,235,.12)":"0 1px 3px rgba(0,0,0,0.04)",
                      transition:"all .15s"
                    }}>
                    <div style={{fontSize:9,fontFamily:"monospace",color:"#94a3b8",marginBottom:4}}>{item.id}</div>
                    <div style={{fontSize:11,fontWeight:700,color:"#374151",marginBottom:8,lineHeight:1.3}}>{item.name}</div>
                    <div style={{fontSize:20,fontWeight:800,color:"#374151",lineHeight:1}}>{item.qty} <span style={{fontSize:11,color:"#94a3b8",fontWeight:400}}>chiếc</span></div>
                    <div style={{fontSize:9,color:"#94a3b8",marginBottom:8}}>Sử dụng từ {item.since}</div>
                    <div style={{display:"flex",justifyContent:"space-between",alignItems:"center"}}>
                      <span style={{background:ss.bg,color:ss.color,padding:"2px 7px",
                        borderRadius:8,fontSize:9,fontWeight:600}}>{ss.label}</span>
                      {item.alarm&&<span style={{width:16,height:16,borderRadius:"50%",background:"#ef4444",
                        display:"inline-flex",alignItems:"center",justifyContent:"center",
                        fontSize:8,color:"white",fontWeight:900}}>!</span>}
                    </div>
                  </div>
                )
              })}
            </div>
          )}
        </div>

        {/* Detail panel */}
        <div style={{
          width:268,background:"white",borderLeft:"1px solid #e2e8f0",
          flexShrink:0,overflowY:"auto"
        }}>
          {!selectedItem ? (
            <div style={{height:"100%",display:"flex",flexDirection:"column",
              alignItems:"center",justifyContent:"center",
              color:"#94a3b8",fontSize:12,padding:20,textAlign:"center",gap:8}}>
              <span style={{fontSize:32}}>⚙</span>
              <span style={{fontWeight:600,color:"#64748b"}}>Chưa chọn đối tượng</span>
              <span style={{fontSize:11,color:"#cbd5e1",lineHeight:1.5}}>
                Nhấp vào một thiết bị để hiển thị thông tin
              </span>
            </div>
          ) : (()=>{
            const item = selectedItem
            const ss = PXLG_STATUS_STYLES[item.status]||PXLG_STATUS_STYLES.ok
            const trend = Array.from({length:20},(_,i)=>
              20+Math.abs(Math.sin(i/3))*60+(Math.random()-.5)*10
            )
            return (
              <div>
                <div style={{padding:"10px 14px",background:"#f8fafc",
                  borderBottom:"1px solid #e2e8f0",
                  display:"flex",alignItems:"center",justifyContent:"space-between"}}>
                  <div>
                    <span style={{fontSize:9,color:"#94a3b8",fontFamily:"monospace"}}>{item.id} · </span>
                    <span style={{fontSize:12,fontWeight:700,color:"#0f172a"}}>{item.name}</span>
                  </div>
                  {item.alarm&&<span style={{width:18,height:18,borderRadius:"50%",background:"#ef4444",
                    display:"inline-flex",alignItems:"center",justifyContent:"center",
                    fontSize:9,color:"white",fontWeight:900}}>!</span>}
                </div>
                <div style={{display:"flex",borderBottom:"1px solid #f1f5f9"}}>
                  {["Thông tin","Lịch sử","Cảnh báo"].map((t,i)=>(
                    <button key={t} style={{padding:"8px 10px",border:"none",cursor:"pointer",fontSize:11,
                      fontWeight:i===0?700:400,color:i===0?"#2563eb":"#94a3b8",
                      borderBottom:i===0?"2px solid #2563eb":"2px solid transparent",
                      background:"none"}}>{t}</button>
                  ))}
                </div>
                <div style={{padding:"14px",display:"flex",alignItems:"center",
                  gap:10,background:"white",borderBottom:"1px solid #f1f5f9"}}>
                  <div style={{flex:1}}>
                    <div style={{fontSize:24,fontWeight:800,color:"#374151",lineHeight:1}}>
                      {item.qty} <span style={{fontSize:13,fontWeight:400,color:"#94a3b8"}}>chiếc</span>
                    </div>
                    <div style={{fontSize:11,color:"#94a3b8",marginTop:2}}>Sử dụng từ {item.since}</div>
                  </div>
                  <span style={{background:ss.bg,color:ss.color,padding:"3px 10px",
                    borderRadius:10,fontSize:10,fontWeight:600}}>{ss.label}</span>
                </div>
                {[
                  ["Mã máy",     item.id],
                  ["Loại",       item.type],
                  ["Số lượng",   `${item.qty} chiếc`],
                  ["Ngày SD",    item.since],
                  ["Trạng thái", ss.label],
                  ["Cảnh báo",   item.alarm?"Có":"Không"],
                ].map(([k,v])=>(
                  <div key={k} style={{display:"flex",justifyContent:"space-between",
                    padding:"7px 14px",borderBottom:"1px solid #f8fafc"}}>
                    <span style={{fontSize:11,color:"#94a3b8"}}>{k}</span>
                    <span style={{fontSize:11,fontWeight:600,
                      color:k==="Cảnh báo"&&item.alarm?"#ef4444":"#0f172a"}}>{v}</span>
                  </div>
                ))}
                <div style={{padding:"8px 14px 2px",fontSize:9,fontWeight:700,
                  color:"#94a3b8",letterSpacing:1,background:"#f8fafc",marginTop:4}}>GIỜ VỪA QUA</div>
                <div style={{padding:"6px 14px 14px",background:"#f8fafc"}}>
                  <div style={{display:"flex",alignItems:"flex-end",gap:1,height:52}}>
                    {trend.map((v,i)=>(
                      <div key={i} style={{flex:1,height:`${v}%`,
                        background:item.alarm?"#ef4444":"#22c55e",
                        borderRadius:"1px 1px 0 0",opacity:0.8}}/>
                    ))}
                  </div>
                  <div style={{display:"flex",justifyContent:"space-between",marginTop:3}}>
                    <span style={{fontSize:7,color:"#94a3b8"}}>-1h</span>
                    <span style={{fontSize:7,color:"#94a3b8"}}>hiện tại</span>
                  </div>
                </div>
              </div>
            )
          })()}
        </div>
      </div>
      </>
      )}
    </div>
  )
}



export default PXLGPanel
